<template>
	<div class="counselorBack">
		<!-- --- header -->
		<v-app-bar app class="couselorHead">
			<div style="width:100%">
				<v-layout class="bigHeader" align-center>
					{{ reservedaysData.title }}
					<v-spacer />
					<!-- 상담사명, 로그아웃  -->
					<span class="counselorid">{{ $store.state.counserlorLoginData.name }} </span>
					<span class="counselorid ml-5"> {{ $store.state.counserlorLoginData.counselorid }}</span>

					<v-divider vertical class="mx-4 my-2 vertical_divider" />

					<v-btn icon depressed small @click="logout" class="mr-4">
						<v-icon medium>
							mdi-logout
						</v-icon></v-btn
					>
					<!-- <btn :btn="logoutbtn" btn_txt="Logout" @click="logout"></btn> -->
				</v-layout>
			</div>
		</v-app-bar>
		<v-layout class="counselorContents" wrap>
			<v-flex xs12>
				<!-- --- 왼쪽 content  -->
				<div class="counselor_content_wrap">
					<!-- viewport  -->
					<v-layout column :class="$vuetify.breakpoint.xs ? 'pre-viewport_counselor rounded' : 'pre-viewport_counselor ml-5 rounded'">
						<v-layout wrap class="mb-2">
							<v-flex xs12>
								<!-- --- 고객 이름, 휴대전화번호 -->
								<div class="mt-4">
									<p class="mb-1 rightSort"><v-icon small color="black">mdi-square</v-icon> 대기 고객 리스트</p>
									<v-layout align-center>
										<txtField :txtField="search_waiting" v-model="search_waiting.value" class="customerInfo"></txtField>
										<btn class="ml-2 mt-1" :btn="sendBtn" :disabled="waitNum === 0" btn_txt="새로고침" @click="waitings()"></btn>
									</v-layout>
									<datatable
										:search="search_waiting.value"
										:datatable="datatable_reserveusers"
										@reserve_pass="reserve_pass"
										@reserve_btn="reserve_btn"
										class="tbl-type01"
									/>
								</div>
								<p class="mb-1 rightSort"><v-icon small color="black">mdi-square</v-icon> 이름, 휴대전화번호를 확인해 주세요</p>
								<v-layout align-center>
									<txtField :txtField="nameTxtfield" v-model="nameTxtfield.value" class="customerInfo mr-2"></txtField>
									<txtField :txtField="phoneTxtfield" v-model="phoneTxtfield.value" class="customerInfo mr-2"></txtField>
								</v-layout>
								<div class="mt-4" style="width:100%">
									<p class="waitNum">
										| 상담고객 총: <span>{{ waitNum }}</span
										>명 대기중
									</p>
									<v-divider class="my-2" />
									<!-- <btn
										v-show="!directSetting"
										v-if="!counseringData.name"
										:btn="sendBtn"
										:disabled="waitNum === 0"
										btn_txt="고객확인"
										@click="send"
									></btn> -->
									<btn
										v-show="!directSetting"
										v-if="nameTxtfield.value"
										:btn="sendBtn"
										btn_txt="담당자 지정"
										@click="complete('no-type')"
									></btn>
									<btn
										v-show="!directSetting && !phoneTxtfield.value"
										class="ml-2"
										:btn="sendBtn"
										btn_txt="담당자 수기 지정"
										@click="directwaitingDailog"
									></btn>
									<btn v-show="directSetting" :btn="sendBtn" btn_txt="담당자 지정" @click="createDirectwaitingDailog"></btn>
									<btn v-show="directSetting" class="ml-2" :btn="sendBtn" btn_txt="취소" @click="directSetting = false"></btn>
								</div>
							</v-flex>
							<v-flex xs12 v-if="directSetting">
								<v-layout align-center>
									<txtField :txtField="direct.nameTxtfield" v-model="direct.nameTxtfield.value" class="customerInfo"></txtField>
									<v-text-field
										outlined
										label="고객 휴대전화번호"
										placeholder="고객 휴대전화번호"
										class="customerInfo-phone ml-4 mt-2"
										color="primary"
										v-mask="'###-####-####'"
										v-model="direct.phoneTxtfield.value"
										hide-details
									></v-text-field>
								</v-layout>
							</v-flex>
							<div class="mt-4">
								<p class="mb-1 rightSort">
									<v-icon small color="black">mdi-square</v-icon> 담당자 수기 지정 혹은 지정 상담사가 없을시 총괄 선택
								</p>
								<v-flex class="search_select ml-3" style="max-width:150px !important;">
									<selectBox :sel="rankSelect" @change="rankSelectChange" :class="'searchSel'" style="font-size:12px"></selectBox>
								</v-flex>
							</div>
							<div class="mt-4">
								<p class="mb-1 rightSort"><v-icon small color="black">mdi-square</v-icon> 지정 상담사 리스트</p>
								<datatable :datatable="datatable_selectMembers" class="tbl-type01" />
							</div>

							<div class="mt-4">
								<p class="mb-1 rightSort"><v-icon small color="black">mdi-square</v-icon> 상담사 리스트</p>
								<v-layout align-center>
									<v-flex class="search_select ml-3" style="max-width:150px !important;">
										<selectBox
											:sel="searchsel2"
											@change="changeRank"
											:class="'searchSel'"
											style="font-size:12px"
											:key="updateSelectBox"
										></selectBox>
									</v-flex>
									<v-flex class="search_select ml-3" style="max-width:150px !important;">
										<selectBox
											:sel="searchsel3"
											@change="changeBonbu"
											:disable="bonbuActive"
											:class="'searchSel'"
											style="font-size:12px"
										></selectBox>
									</v-flex>
									<v-flex class="search_select ml-3 mr-2 " style="max-width:150px !important;">
										<selectBox
											:sel="searchsel1"
											:disable="teamActive"
											@change="changeTeam"
											:class="'searchSel'"
											style="font-size:12px"
										></selectBox>
									</v-flex>
									<v-flex>
										<v-layout align-center>
											<txtField :txtField="searchfield" v-model="searchName" class="searchInput"></txtField>
										</v-layout>
									</v-flex>
								</v-layout>
								<datatable :search="searchName" :datatable="datatable_members" class="tbl-type01" />
							</div>
						</v-layout>
					</v-layout>
				</div>
			</v-flex>
		</v-layout>
		<!-- <v-footer color="white" class="tracking-table">
			<p class="rightSort mt-7"><v-icon small color="black">mdi-square</v-icon> 현재 고객 추적 데이터</p>
			<div>
				<datatable :datatable="datatable" class="tbl-type01" />
			</div>
		</v-footer> -->
		<v-dialog v-model="infoDialog.dialog" width="30vh" persistent>
			<v-card>
				<v-card-title>
					상담원 정보 확인
				</v-card-title>
				<v-card-text class="pb-3">
					<v-layout> 상담원 이름: {{ infoDialog.name }} <br />상담석 번호: {{ infoDialog.seat }} </v-layout>
				</v-card-text>
				<h2 class="ml-6">위의 정보가 맞으십니까?</h2>
				<v-card-actions>
					<v-spacer></v-spacer>
					<btn :btn="infoDialog.btn" :btn_txt="infoDialog.btn.submit" @click="infoDialog.dialog = false"></btn>
					<btn :btn="infoDialog.btn" :btn_txt="infoDialog.btn.logout" @click="selfAuthentication()"></btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
		<alertModal :setdialog="alertModal" :clickDeleteBtnModal="deleteAccount" />
		<alertModal :setdialog="alertModal4" :clickDeleteBtnModal="waitingPass" />
		<alertModal :setdialog="sendAlertModal" :clickDeleteBtnModal="createSendMessage" />
		<alertModal2 :setdialog="alertModal2" />
		<alertModal3 :setdialog="alertModal3" :userExport="userExport" :type="'co'" />
		<v-dialog v-model="direct_dialog" persistent min-width="800px" content-class="waitingDialog">
			<v-layout class="counselorContents mt-0" wrap>
				<v-flex xs12>
					<!-- --- 왼쪽 content  -->
					<div>
						<!-- viewport  -->
						<v-layout column :class="$vuetify.breakpoint.xs ? 'pre-viewport_counselor rounded' : 'pre-viewport_counselor ml-5 rounded'">
							<v-layout wrap class="mb-2">
								<v-flex xs12>
									<!-- --- 고객 이름, 휴대전화번호 -->
									<v-layout align-center>
										<p class="mb-1 rightSort">
											<v-icon small color="black">mdi-square</v-icon> 이름, 휴대전화번호, 대기번호를 입력해 주세요
										</p>
										<v-spacer></v-spacer>
										<v-btn icon @click="direct_dialog = !direct_dialog">
											<v-icon>mdi-close</v-icon>
										</v-btn>
									</v-layout>

									<v-layout align-center>
										<txtField :txtField="direct.nameTxtfield" v-model="direct.nameTxtfield.value" class="customerInfo"></txtField>
										<v-text-field
											outlined
											label="고객 휴대전화번호"
											placeholder="고객 휴대전화번호"
											class="customerInfo-phone ml-4 mt-2"
											color="primary"
											v-mask="'###-####-####'"
											v-model="direct.phoneTxtfield.value"
											hide-details
										></v-text-field>
									</v-layout>
								</v-flex>
								<btn
									:btn="sendBtn"
									btn_txt="취소"
									@click=";(counselorInputDirect = false), (rankSelect.value = null), (direct.phoneTxtfield.value = null)"
								></btn>
								<btn class="ml-2" :btn="sendBtn" btn_txt="등록하기" @click="createDirectwaitingDailog"></btn>
							</v-layout>
						</v-layout>
					</div>
				</v-flex>
			</v-layout>
		</v-dialog>
		<agree-dialog :setdialog="agreeDialog" />
	</div>
</template>

<script>
import location1 from '../../utils/location1'
import location2 from '../../utils/location2'

import { agreeDialog, alertModal, alertModal2, alertModal3, btn, datatable, txtField, selectBox } from '@/components/index'
export default {
	components: {
		txtField,
		alertModal,
		btn,
		selectBox,
		alertModal2,
		alertModal3,
		datatable,
		agreeDialog,
	},
	data() {
		return {
			updateSelectBox: 0,
			directSetting: false,
			searchName: '',
			searchfield: {
				height: '26',
				value: '',
				color: 'primary',
				outlined: true,
				placeholder: '검색어를 입력해 주세요.',
			},
			searchsel1: {
				clearable: true,
				value: null,
				errorMessage: '',
				hideDetail: true,
				items: [],
				outlined: true,
				placeholder: '팀',
				returnObject: true,
				itemText: 'title',
			},
			rankSelect: {
				clearable: true,
				value: null,
				errorMessage: '',
				hideDetail: true,
				items: [],
				outlined: true,
				placeholder: '총괄',
				returnObject: true,
				itemText: 'rankName',
			},
			searchsel2: {
				clearable: true,
				value: null,
				errorMessage: '',
				hideDetail: true,
				items: [],
				outlined: true,
				placeholder: '총괄',
				returnObject: true,
				itemText: 'rankName',
			},
			searchsel3: {
				clearable: true,
				value: null,
				errorMessage: '',
				hideDetail: true,
				items: [],
				outlined: true,
				placeholder: '본부',
				returnObject: true,
				itemText: 'title',
			},
			rankData: [],
			teamData: [],
			bonbuData: [],
			bonbuActive: true,
			teamActive: true,
			counselorInputDirect: false,
			counselorInput: false,
			check2: {
				color: 'primary',
				class: 'smallLabel',
				value: false,
				label: '개인정보 수집동의',
				onicon: 'mdi-check-circle',
				officon: 'mdi-check-circle-outline',
			},
			agreeDialog: {
				dialog: false,
				title: '',
				content: '',
			},
			componentKey: 0,
			search_waiting: {
				value: '',
				color: 'primary',
				outlined: true,
				placeholder: '검색어를 입력해주세요.',
			},
			direct: {
				custComment: '',
				radios: {
					radioSelected: '',
					items: [
						{ label: 'S', value: 'S' },
						{ label: 'A', value: 'A' },
						{ label: 'B', value: 'B' },
						{ label: 'C', value: 'C' },
						{ label: 'D', value: 'D' },
					],
					color: '#202840',
				},

				nameTxtfield: {
					value: '',
					color: 'primary',
					outlined: true,
					label: '고객성명',
					placeholder: '고객성명',
				},
				phoneTxtfield: {
					value: '',
					outlined: true,
					label: '고객 휴대전화번호',
					placeholder: '고객 휴대전화번호',
					type: 'Number',
					onlyNumber: true,
					max: 99999999999999999999999,
				},
			},
			direct_dialog: false,
			realTimeWatingList: [],
			infoDialog: {
				dialog: true,
				btn: {
					submit: '예',
					logout: '아니오',
					outlined: true,
				},
			},
			selectedTag: [],
			datatable_selectMembers: {
				headers: [
					{ text: '총괄', value: 'rankTitle' },
					{ text: '본부', value: 'bonbuTitle' },
					{ text: '팀', value: 'teamTitle' },
					{ text: '상담사 명', value: 'name' },
					{ text: '상담사 가명', value: 'nickname' },
					{ text: '상담사 번호', value: 'phoneNumber' },
					{ text: '상담사 대표번호', value: 'salesPhoneNumber' },
					{ text: '선택', value: 'checkId' },
				],
				items: [],
				hidedefaultfooter: false,
				noweditting: '',
				itemPerPage: 5,
				page: 1,
				pageCount: 0,
			},
			datatable_members: {
				headers: [
					{ text: '총괄', value: 'rankTitle' },
					{ text: '본부', value: 'bonbuTitle' },
					{ text: '팀', value: 'teamTitle' },
					{ text: '상담사 명', value: 'name' },
					{ text: '상담사 가명', value: 'nickname' },
					{ text: '상담사 번호', value: 'phoneNumber' },
					{ text: '상담사 대표번호', value: 'salesPhoneNumber' },
					{ text: '선택', value: 'checkId' },
				],
				items: [],
				hidedefaultfooter: false,
				noweditting: '',
				itemPerPage: 5,
				page: 1,
				pageCount: 0,
			},
			datatable_reserveusers: {
				headers: [
					{ text: '고객명', value: 'name' },
					{ text: '고객전화번호', value: 'phone' },
					{ text: '지명 확인', value: 'reserve_btn' },
					{ text: '고객패스', value: 'reserve_pass' },
				],
				items: [],
				hidedefaultfooter: false,
				noweditting: '',
				itemPerPage: 5,
				page: 1,
				pageCount: 3,
			},
			datatable: {
				headers: [
					{ text: '상담 날짜', value: 'cdate' },
					{ text: '사업지 명', value: 'title' },
					{ text: '상담사 아이디', value: 'counselorid' },
					{ text: '고객 등급', value: 'custlike' },
					{ text: '코멘트 태그', value: 'commentTag' },
					{ text: '코멘트', value: 'recomand' },
					{ text: '방문 예약 날짜', value: 'rdate' },
				],
				items: [],
				hidedefaultfooter: true,
				noweditting: '',
				itemPerPage: 5,
				page: 1,
				pageCount: 3,
			},
			// --- header 텍스트 data---
			header: { headerTitle: 'test : 더샵과 함께 아산의 내일이 빛난다!', bigHeader: '테스트 캠페인 타이틀' },
			// -- 체크박스 data
			check1: {
				color: 'primary',
				class: 'smallLabel',
				value: false,
				label: '개인정보 수집동의',
				readonly: true,
			},
			check3: {
				color: 'primary',
				class: 'smallLabel',
				value: false,
				label: '동의 없이 상담 진행',
			},
			// --- 고객 성명, 전화번호 텍스트 박스 ---
			nameTxtfield: {
				value: '',
				outlined: true,
				label: '고객성명',
				placeholder: '고객성명',
				readonly: true,
			},
			phoneTxtfield: {
				value: '',
				outlined: true,
				label: '고객 휴대전화번호',
				placeholder: '고객 휴대전화번호',
				readonly: true,
			},
			waitingNumTxtfield: {
				value: '',
				outlined: true,
				label: '고객 대기번호',
				placeholder: '고객 대기번호',
				readonly: true,
			},
			// --- 고객성향 radio button
			radios: {
				radioSelected: '',
				items: [
					{ label: 'S', value: 'S' },
					{ label: 'A', value: 'A' },
					{ label: 'B', value: 'B' },
					{ label: 'C', value: 'C' },
					{ label: 'D', value: 'D' },
				],
				color: '#202840',
			},
			// --- 로그아웃 모달 ---
			alertModal2: {
				dialog: false,
				text: '로그아웃 하시겠습니까?',
				btnText: '로그아웃',
			},
			alertModal4: {
				dialog: false,
				text: '고객을 패스 하시겠습니까?',
				btnText: '패스',
			},
			alertModal: {
				dialog: false,
				text: '로그아웃 하시겠습니까?',
			},
			sendAlertModal: {
				dialog: false,
				text: '고객을 호출하기 위해 알림톡을 전송 하시겠습니까?',
				btnText: '보내기',
			},
			logoutbtn: {
				class: '',
				color: 'primary',
				dark: true,
			},
			sendBtn: {
				color: '#202840',
				dark: false,
				class: 'white--text',
			},
			historyBtn: {
				dark: true,
				color: '#202840',
			},
			waitNum: 0,

			draggableDisable: false,
			viewportList: [],
			inputBoxesData: [],
			groups: [],
			locationSelected: '',
			picker: {
				date: '',
				errorMessage: '',
				allowedDates: '2021-5-30',
			},
			timeData: [],
			selectedTime: '',
			sel1: { label: '설문', value: '', errorMessage: '', hideDetail: true, items: [], outlined: true }, // 인풋박스 셀렉트 박스 옵션
			sel2: { label: '사업지', value: '', errorMessage: '', hideDetail: true, items: [], outlined: true }, // 사업지 셀렉트 박스 옵션
			sel3: { label: '', value: '', errorMessage: '', hideDetail: true, outlined: true }, // viewport 셀렉트 박스 옵션
			txt: {
				value: '',
				maxlength: '255',
				outlined: true,
				autofocus: false,
				hideDetail: false,
				errorMessage: '',
			},
			reservedaysData: {
				business: { color: 'black' },
			},
			counseringData: {},
			waitingId: '',
			custComment: '', // 고객 코멘트 v-model
			commentTxtfield: {
				height: 70,
				noresize: '',
				value: '',
				outlined: true,
				placeholder: '',
				readonly: false,
			}, // 고객 코멘트 텍스트 필드 옵션
			//히스토리 모달
			alertModal3: {
				dialog: false,
				text: '로그아웃 하시겠습니까?',
				datatable: { headers: [], items: [] },
				json_fields: {},
			},
			socket: '',
			userLists: [],
			waitingItem: null,
		}
	},
	created() {
		if (localStorage.getItem('counserlor') === null) {
			this.$router.push({ name: 'counselorlogin' })
		}
		this.counselors(localStorage.getItem('counserlor').split(',')[1])
		this.reservedays()
		this.waitings()
	},
	async mounted() {
		// 잠시 홀드
		await this.ranksDatas()
		await this.viewUsers()
		this.waitingsSocket() // socket method
	},
	methods: {
		reserve_pass(item) {
			this.waitingItem = item
			this.alertModal4.dialog = true
			this.nameTxtfield.value = null
			this.phoneTxtfield.value = null
		},
		waitingPass() {
			this.$store.dispatch('updateWaiting', { id: this.waitingItem.id, receiveInformation: false, stat: 2 }).then(() => {
				this.waitingItem = null
				this.alertModal4.dialog = false
				this.waitings()
			})
		},
		reserve_btn(item) {
			this.waitingId = item.id
			this.nameTxtfield.value = item.name
			this.phoneTxtfield.value = item.phone

			this.assignments(item.phone)
		},
		rankSelectChange(val) {
			if (val) this.$store.state.counselor_reserve = val.users_permissions_user.id
			else this.$store.state.counselor_reserve = null
		},
		// 전화번호 형식 변환 함수
		formatPhoneNumber(phoneNumber) {
			// 문자열로 변환하고 숫자가 아닌 문자 제거
			const cleaned = phoneNumber.toString().replace(/\D/g, '')

			// 길이별 형식 변환
			if (cleaned.length === 11) {
				// 010-1234-5678 형식 (휴대폰)
				return cleaned.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3')
			} else if (cleaned.length === 10) {
				// 02-1234-5678 형식 (서울 지역번호) 또는 031-123-4567 형식
				if (cleaned.startsWith('02')) {
					return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3')
				} else {
					return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
				}
			} else if (cleaned.length === 9) {
				// 02-123-4567 형식 (서울 지역번호 짧은 형식)
				if (cleaned.startsWith('02')) {
					return cleaned.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3')
				} else {
					return cleaned.replace(/(\d{3})(\d{3})(\d{3})/, '$1-$2-$3')
				}
			} else if (cleaned.length === 8) {
				// 1234-5678 형식 (지역번호 없는 경우)
				return cleaned.replace(/(\d{4})(\d{4})/, '$1-$2')
			}

			// 기본적으로 원본 반환
			return phoneNumber
		},
		async assignments(phone) {
			await this.$store
				.dispatch('assignments', { phone: this.formatPhoneNumber(phone) })
				.then(res => {
					this.datatable_selectMembers.items = this.userLists.filter(x => res.map(x => x.userID).indexOf(String(x.id)) > -1)
				})
				.catch(err => {
					console.log({ err })
				})
		},
		async dataSetting() {
			for (let index = 0; index < this.userLists.length; index++) {
				const element = this.userLists[index]
				if (element.teamApply) {
					element.teamTitle =
						this.teamData.filter(x => String(x.id) === element.teamApply).length > 0
							? this.teamData.filter(x => String(x.id) === element.teamApply)[0].title
							: ''
					if (this.teamData.filter(x => String(x.id) === element.teamApply).length > 0) {
						element.bonbuTitle =
							this.bonbuData.filter(x => String(x.id) === this.teamData.filter(x => String(x.id) === element.teamApply)[0].bonbuID).length >
							0
								? this.bonbuData.filter(x => String(x.id) === this.teamData.filter(x => String(x.id) === element.teamApply)[0].bonbuID)[0]
										.title
								: ''
						if (this.bonbuData.filter(x => String(x.id) === this.teamData.filter(x => String(x.id) === element.teamApply)[0].id).length > 0)
							element.rankID = this.bonbuData.filter(
								x => String(x.id) === this.teamData.filter(x => String(x.id) === element.teamApply)[0].bonbuID,
							)[0].rankID
						element.bonbuID = String(
							this.bonbuData.filter(x => String(x.id) === this.teamData.filter(x => String(x.id) === element.teamApply)[0].bonbuID)[0].id,
						)
						element.teamID = String(this.teamData.filter(x => String(x.id) === element.teamApply)[0].id)
						element.rankTitle =
							this.rankData.filter(
								x =>
									String(x.id) ===
									this.bonbuData.filter(x => String(x.id) === this.teamData.filter(x => String(x.id) === element.teamApply)[0].bonbuID)[0]
										.rankID,
							).length > 0
								? this.rankData.filter(
										x =>
											String(x.id) ===
											this.bonbuData.filter(
												x => String(x.id) === this.teamData.filter(x => String(x.id) === element.teamApply)[0].bonbuID,
											)[0].rankID,
								  )[0].rankName
								: ''
					}
				} else {
					element.teamTitle =
						this.teamData.filter(x => String(x.id) === element.teamID).length > 0
							? this.teamData.filter(x => String(x.id) === element.teamID)[0].title
							: ''
					element.rankTitle =
						this.rankData.filter(x => String(x.id) === element.rankID).length > 0
							? this.rankData.filter(x => String(x.id) === element.rankID)[0].rankName
							: ''
					element.bonbuTitle =
						this.bonbuData.filter(x => String(x.id) === element.bonbuID).length > 0
							? this.bonbuData.filter(x => String(x.id) === element.bonbuID)[0].title
							: ''
				}
			}
			this.datatable_members.items = JSON.parse(JSON.stringify(this.userLists))
		},
		async viewUsers() {
			this.$store.state.loading = true

			await this.$store
				.dispatch('users_members', {})
				.then(async res => {
					this.$store.state.loading = false
					this.userLists = res
					await this.dataSetting()
				})
				.catch(err => {
					console.log({ err })
					this.$store.state.loading = false
				})
		},
		counselorSearch() {},
		changeTeam(val) {
			if (val) {
				this.datatable_members.items = this.userLists.filter(item => {
					return (
						item.teamID === String(val.id) &&
						item.rankID === String(this.searchsel2.value.id) &&
						item.bonbuID === String(this.searchsel3.value.id)
					)
				})
			} else {
				this.datatable_members.items = this.userLists.filter(item => {
					return item.rankID === String(this.searchsel2.value.id) && item.bonbuID === String(this.searchsel3.value.id)
				})
			}
		},
		changeRank(val) {
			if (val) {
				this.bonbuActive = false
				this.teamActive = true
				this.searchsel3.value = null
				this.searchsel3.items = this.bonbuData.filter(item => item.rankID === String(val.id))
				this.datatable_members.items = this.userLists.filter(item => {
					return item.rankID === String(val.id)
				})
			} else {
				this.bonbuActive = true
				this.teamActive = true
				this.searchsel3.value = null
				this.datatable_members.items = this.userLists
			}
		},
		changeBonbu(val) {
			if (val) {
				this.teamActive = false
				this.searchsel1.value = null
				this.searchsel1.items = this.teamData.filter(item => item.bonbuID === String(val.id))
				this.datatable_members.items = this.userLists.filter(item => {
					return item.bonbuID === String(val.id) && item.rankID === String(this.searchsel2.value.id)
				})
			} else {
				this.teamActive = true
				this.searchsel1.value = null
				this.datatable_members.items = this.userLists.filter(item => {
					return item.rankID === String(this.searchsel2.value.id)
				})
			}
		},
		async ranksDatas() {
			this.$store.state.loading = true
			let data = { _limit: 1000 }
			await this.$store
				.dispatch('ranks', data)
				.then(res => {
					this.searchsel2.items = res
					this.rankSelect.items = res
					this.rankData = JSON.parse(JSON.stringify(res))
				})
				.catch(err => {
					console.log(err)
					this.$store.state.loading = false
				})

			await this.$store
				.dispatch('bonbus', data)
				.then(res => {
					this.searchsel3.items = res
					this.bonbuData = JSON.parse(JSON.stringify(res))
				})
				.catch(err => {
					console.log(err)
					this.$store.state.loading = false
				})
			await this.$store
				.dispatch('teams', data)
				.then(res => {
					this.searchsel1.items = res
					this.teamData = JSON.parse(JSON.stringify(res))
					this.$store.state.loading = false
				})
				.catch(err => {
					console.log(err)
					this.$store.state.loading = false
				})
		},
		changeBtn() {
			if (this.$store.state.check2.value && this.setdialog.numtxtField.value.length > 6 && this.setdialog.nametxtField.value !== '') {
				this.nextBtn.class = 'customBtn'
			} else {
				this.nextBtn.class = 'disabledBtn'
				// this.nextBtn1.color = this.$store.state.PointColor7
			}
		},
		detail(num) {
			this.terms(num)
		},
		terms(num) {
			const data = {
				stat: 1,
				type: num,
			}
			this.$store.dispatch('terms', data).then(res => {
				this.agreeDialog.dialog = true
				if (res.data.terms.length > 0) {
					this.agreeDialog.title = res.data.terms[0].title
					this.agreeDialog.content = res.data.terms[0].content
				}
			})
		},
		createDirectwaitingDailog() {
			let ok = 0
			if (this.direct.phoneTxtfield.value === '') {
				this.alertModal2.dialog = true
				this.alertModal2.text = '고객 휴대전화번호를 입력해 주세요.'
				ok += 1
				return
			}
			if (this.direct.nameTxtfield.value === '') {
				this.alertModal2.dialog = true
				this.alertModal2.text = '고객 이름을 입력해 주세요.'
				ok += 1
				return
			}
			if (!this.$store.state.counselor_reserve) return alert('담당자를 선택해 주세요.')
			if (this.userLists.filter(x => String(x.id) === String(this.$store.state.counselor_reserve)).length === 0)
				return alert('담당자를 선택해 주세요.')

			const userData = this.userLists.filter(x => String(x.id) === String(this.$store.state.counselor_reserve))[0]

			const checkBox = []
			const checkone = []
			const textfiled = []
			let userDataInput = []
			let sex = null
			let realname = null
			let age = null
			let qualification = null
			let homeOwnership = null
			let bankBook = null
			let purpose = null
			let subscribe = null
			let floor = null
			let houseAcreage = null
			let acreageUnit = null
			let location = null
			let locationType = null
			this.$store.state.reservedayInputBoxDirect.categories.forEach(obj => {
				if (obj.tag === 'name') {
					realname = obj.items.value
				} else if (obj.tag === 'age') {
					if (obj.category_details.length > 0 && obj.value)
						age = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'sex') {
					if (obj.category_details.length > 0 && obj.value)
						sex = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'qualification') {
					if (obj.category_details.length > 0 && obj.value)
						qualification = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'homeOwnership') {
					if (obj.category_details.length > 0 && obj.value)
						homeOwnership = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'bankBook') {
					if (obj.category_details.length > 0 && obj.value)
						bankBook = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'purpose') {
					if (obj.category_details.length > 0 && obj.value)
						purpose = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'subscribe') {
					if (obj.category_details.length > 0 && obj.value)
						subscribe = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'floor') {
					if (obj.category_details.length > 0 && obj.value)
						floor = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'houseAcreage') {
					if (obj.category_details.length > 0 && obj.value) {
						houseAcreage = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
						acreageUnit = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].etc
					}
				} else if (obj.tag === 'locationType') {
					if (obj.category_details.length > 0 && obj.value) {
						location = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
						locationType = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].etc
					}
				}
				if (obj.type === 10) {
					checkone.push(obj.code + ':' + obj.value)
				} else if (obj.type === 11) {
					checkBox.push(obj.code + ':' + obj.items.map(x => x.value).join(','))
				} else if (obj.type === 12) {
					checkone.push(obj.code + ':' + obj.items.value)
				} else if (obj.type === 20) {
					textfiled.push(obj.code + ':' + obj.items.value)
				}
				if (obj.type === 10) {
					userDataInput.push({
						musthave: obj.musthave,
						explain: obj.explain,
						code: obj.code,
						codename: obj.codename,
						contents: obj.contents,
						tag: obj.tag,
						type: obj.type,
						qusType: '객관식(단일선택)',
						category_details: obj.category_details,
						value:
							obj.category_details.filter(x => x.detailcode === obj.value).length > 0
								? obj.category_details.filter(x => x.detailcode === obj.value)[0].detailname
								: '무응답',
						reserveGroupCode: this.$route.params.subCode,
					})
				} else if (obj.type === 11) {
					userDataInput.push({
						musthave: obj.musthave,
						explain: obj.explain,
						code: obj.code,
						codename: obj.codename,
						contents: obj.contents,
						tag: obj.tag,
						type: obj.type,
						qusType: '객관식(다중선택)',
						category_details: obj.category_details,
						value:
							obj.items.filter(x => x.value !== '').length > 0
								? obj.items
										.filter(x => x.value !== '')
										.map(x => x.label)
										.join(',')
								: '무응답',
						reserveGroupCode: this.$route.params.subCode,
					})
				} else if (obj.tag === 'location') {
					userDataInput.push({
						musthave: obj.musthave,
						explain: obj.explain,
						code: obj.code,
						codename: obj.codename,
						contents: obj.contents,
						tag: obj.tag,
						type: obj.type,
						qusType: '지역',
						category_details: obj.category_details,
						value:
							this.$store.state.searchsel_city1.value +
							'_' +
							this.$store.state.searchsel_city2.value +
							'_' +
							this.$store.state.searchsel_city3.value,
						reserveGroupCode: this.$route.params.subCode,
					})
				} else if (obj.type === 20) {
					userDataInput.push({
						musthave: obj.musthave,
						explain: obj.explain,
						code: obj.code,
						codename: obj.codename,
						contents: obj.contents,
						tag: obj.tag,
						type: obj.type,
						category_details: obj.category_details,
						value: obj.items.value,
						qusType: '주관식',
						reserveGroupCode: this.$route.params.subCode,
					})
				} else if (obj.type === 21) {
					userDataInput.push({
						musthave: obj.musthave,
						explain: obj.explain,
						code: obj.code,
						codename: obj.codename,
						contents: obj.contents,
						tag: obj.tag,
						type: obj.type,
						category_details: obj.category_details,
						qusType: '파일업로드',
						imgFiles: this.imgFiles,
						reserveGroupCode: this.$route.params.subCode,
					})
				}
			})
			const data = {
				title: this.reservedaysData.title,
				inputBoxTitle: this.$store.state.reservedayInputBox.name,
				ismarketing: 1,
				ispersonal: 1,
				stat: 9,
				name: this.direct.nameTxtfield.value,
				phone: this.direct.phoneTxtfield.value.replace(/-/g, ''),
				custlike: this.direct.radios.radioSelected,
				checkbox: checkBox.join('/'),
				textfiled: textfiled.join('/'),
				checkone: checkone.join('/'),
				date: this.$moment(new Date()).add(9, 'hour'),
				counselorid: this.$store.state.counserlorLoginData.counselorid
					? this.$store.state.counserlorLoginData.counselorid
					: localStorage.getItem('counserlor').split(',')[1],
				rdate: this.$moment(new Date()).add(9, 'hour'),
				cdate: this.$moment(new Date()).add(9, 'hour'),
				recomand: this.direct.custComment,
				code: this.$route.params.code,
				seat: Number(this.$store.state.counserlorLoginData.seat),
				locationData:
					this.$store.state.reservedayInputBoxDirect.categories.map(x => x.type).indexOf(20) > -1
						? this.$store.state.searchsel_city1.value +
						  '_' +
						  this.$store.state.searchsel_city2.value +
						  '_' +
						  this.$store.state.searchsel_city3.value
						: '',
				userData: userDataInput,
				sex: sex,
				realname: realname,
				age: age,
				qualification: qualification,
				homeOwnership: homeOwnership,
				bankBook: bankBook,
				purpose: purpose,
				subscribe: subscribe,
				floor: floor,
				houseAcreage: houseAcreage,
				acreageUnit: acreageUnit,
				business: this.reservedaysData.business ? Number(this.reservedaysData.business.id) : null,
				marketing: this.$store.state.check5.value,
				receiveInformation: this.$store.state.check6.value,
				location: location,
				locationType: locationType,
				commentTag: `${userData.rankTitle ? userData.rankTitle : ''} ${userData.bonbuTitle ? userData.bonbuTitle : ''} ${
					userData.teamTitle ? userData.teamTitle : ''
				} ${userData.name ? userData.name : ''}`,
				groupcode: userData.phoneNumber,
			}
			if (ok === 0) {
				this.$store
					.dispatch('createWaiting', data)
					.then(() => {
						const nickname = `${userData.rankTitle ? userData.rankTitle : ''} ${userData.bonbuTitle ? userData.bonbuTitle : ''} ${
							userData.teamTitle ? userData.teamTitle : ''
						} ${userData.nickname ? userData.nickname : userData.name}`
						this.createSendSm(this.direct.phoneTxtfield.value, userData.nickname ? nickname : data.commentTag, userData.phoneNumber)
						this.createSendSm_counselor(userData.phoneNumber, this.direct.nameTxtfield.value, this.direct.phoneTxtfield.value)
						this.$store.state.loading = false
						// if (this.reservedaysData.tplCode[11]) this.completeSendMessage_11()
						// else {
						this.$store.state.counselor_reserve = null
						this.datatable_selectMembers.items = []
						this.directSetting = false
						this.rankSelect.value = null
						this.updateSelectBox += 1
						this.cancelDirectwaitingDailog()
						// }
						alert('상담수기 등록이 완료되었습니다.')
					})
					.catch(() => {
						alert('상담수기 등록시 오류가 발생하였습니다. 관리자에게 문의하세요.')
						this.$store.state.loading = false
					})
			}
		},
		cancelDirectwaitingDailog() {
			this.direct_dialog = false
			this.direct = {
				custComment: '',
				radios: {
					radioSelected: '',
					items: [
						{ label: 'S', value: 'S' },
						{ label: 'A', value: 'A' },
						{ label: 'B', value: 'B' },
						{ label: 'C', value: 'C' },
						{ label: 'D', value: 'D' },
					],
					color: '#202840',
				},
				nameTxtfield: {
					value: '',
					outlined: true,
					label: '고객성명',
					placeholder: '고객성명',
				},
				phoneTxtfield: {
					value: '',
					outlined: true,
					label: '고객 휴대전화번호',
					placeholder: '고객 휴대전화번호',
				},
			}
		},
		directwaitingDailog() {
			this.rankSelect.value = null
			this.directSetting = true
			this.direct.nameTxtfield.value = ''
			this.direct.phoneTxtfield.value = ''
		},
		async createSendSm(phone, name, counselorPhone) {
			let message = `[청라 피크원] 고객님의 담당자는 [${name}]입니다. 담당자 번호: ${counselorPhone}`
			const data = {
				receiver: phone.replace(/-/g, ''),
				message: message,
				sender: process.env.VUE_APP_SENDER,
				senderkey: process.env.VUE_APP_SENDERKEY,
				pay: name + '/' + counselorPhone,
			}
			await this.$store
				.dispatch('createSendSm', data)
				.then(() => {})
				.catch(err => {
					console.log({ err })
				})
		},
		async createSendSm_counselor(phone, name, customerPhone) {
			if (phone === '010-8634-1093') phone = '010-9416-7468'
			let message = `[청라 피크원] [${name}] 고객님 방문하셨습니다. 고객번호: ${customerPhone}`
			const data = {
				receiver: phone.replace(/-/g, ''),
				message: message,
				sender: process.env.VUE_APP_SENDER,
				senderkey: process.env.VUE_APP_SENDERKEY,
				pay: name + '/' + customerPhone,
			}
			await this.$store
				.dispatch('createSendSm', data)
				.then(() => {})
				.catch(err => {
					console.log({ err })
				})
		},
		completeSendMessage_5() {
			const data = {
				tplCode: this.reservedaysData.tplCode[5],
			}
			this.$store.dispatch('messages', data).then(res => {
				if (res.data.messages[0].message === undefined) {
					// 생성 / 수정시 알림톡 tpl_code가 없는 경우
					return
				} else {
					res.data.messages[0].message = res.data.messages[0].message.replace(/#{사업지명}/g, this.reservedaysData.title)
					res.data.messages[0].message = res.data.messages[0].message.replace(/#{고객명}/g, this.nameTxtfield.value)
				}
				let buttonDatas
				if (res.data.messages[0].button) {
					buttonDatas = JSON.parse(res.data.messages[0].button).button
					buttonDatas.forEach(btn => {
						btn.linkPc = btn.linkPc.replace(/#{코드}/g, this.$route.params.code)
						btn.linkMo = btn.linkMo.replace(/#{코드}/g, this.$route.params.code)
					})
				}
				const sendData = {
					// 필수값

					code: this.$route.params.code,
					sender: res.data.messages[0].smssender,
					senderkey: res.data.messages[0].senderkey,
					tpl_code: res.data.messages[0].tplCode,
					receiver_1: this.phoneTxtfield.value,
					subject_1: res.data.messages[0].tplCodeStr,
					message_1: res.data.messages[0].message,
					recvname_1: this.nameTxtfield.value,
					failover: 'Y',
					fsubject_1: res.data.messages[0].tplCodeStr,
					fmessage_1: res.data.messages[0].message,
					button_1: res.data.messages[0].button ? JSON.stringify(buttonDatas) : '[]',
					pay: this.reservedaysData.business?.id,
				}
				this.$store
					.dispatch('createSendMessage', sendData)
					.then(() => {
						this.nameTxtfield.value = ''
						this.phoneTxtfield.value = ''
					})
					.catch(err => {
						console.log({ err })
					})
			})
		},
		completeSendMessage_10() {
			if (this.reservedaysData.tplCode[11]) {
				const data = {
					tplCode: this.reservedaysData.tplCode[11],
				}
				this.$store.dispatch('messages', data).then(res => {
					if (res.data.messages[0].message === undefined) {
						// 생성 / 수정시 알림톡 tpl_code가 없는 경우
						return
					} else {
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{사업지명}/g, this.reservedaysData.title)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{고객명}/g, this.nameTxtfield.value)
						res.data.messages[0].message = res.data.messages[0].message.replace(
							/#{상담완료일시}/g,
							this.$moment().format('YYYY-MM-DD HH:mm'),
						)
					}
					if (res.data.messages[0].button) {
						const buttonsData = JSON.parse(res.data.messages[0].button).button
						buttonsData.forEach(element => {
							if (element.linkMo) {
								element.linkMo = element.linkMo.replace(/#{그룹}/g, this.$route.params.code)
								element.linkPc = element.linkPc.replace(/#{그룹}/g, this.$route.params.code)
								element.linkMo = element.linkMo.replace(
									/#{코드}/g,
									this.$route.params.code === '8zuur7hjgcx' ? 'du2ct7vcb84' : this.$route.params.code,
								)
								element.linkPc = element.linkPc.replace(
									/#{코드}/g,
									this.$route.params.code === '8zuur7hjgcx' ? 'du2ct7vcb84' : this.$route.params.code,
								)
								element.linkMo = element.linkMo.replace(/#{전화번호}/g, this.phoneTxtfield.value)
								element.linkPc = element.linkPc.replace(/#{전화번호}/g, this.phoneTxtfield.value)
								element.linkMo = element.linkMo.replace(/#{고객명}/g, this.nameTxtfield.value)
								element.linkPc = element.linkPc.replace(/#{고객명}/g, this.nameTxtfield.value)
								element.linkMo = element.linkMo.replace(/#{상담ID}/g, this.phoneTxtfield.value)
								element.linkPc = element.linkPc.replace(/#{상담ID}/g, this.phoneTxtfield.value)
								element.linkMo = element.linkMo.replace(/#{방문ID}/g, this.phoneTxtfield.value)
								element.linkPc = element.linkPc.replace(/#{방문ID}/g, this.phoneTxtfield.value)
								element.linkMo = element.linkMo.replace(
									/#{분양정보pdf}/g,
									this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
								)
								element.linkPc = element.linkPc.replace(
									/#{분양정보pdf}/g,
									this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
								)
								if (this.reservedaysData.business.alertTalkSubscriptionInformation?.url) {
									element.linkMo = element.linkMo.replace(
										/#{청약안내pdf}/g,
										this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
									)
									element.linkPc = element.linkPc.replace(
										/#{청약안내pdf}/g,
										this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
									)
								}
								element.linkMo = element.linkMo.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
								element.linkPc = element.linkPc.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
								element.linkMo = element.linkMo.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
								element.linkPc = element.linkPc.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
								element.linkMo = element.linkMo.replace(/#{url2}/g, this.reservedaysData.business.alertTalkTalk)
								element.linkMo = element.linkMo.replace(/#{url2}/g, this.reservedaysData.business.alertTalkTalk)
							}
						})
						res.data.messages[0].button = JSON.stringify(buttonsData)
					}
					const sendData = {
						// 필수값

						code: this.$route.params.code,
						tpl_code: res.data.messages[0].tplCode,
						sender: res.data.messages[0].smssender,
						senderkey: res.data.messages[0].senderkey,
						receiver_1: this.phoneTxtfield.value,
						subject_1: res.data.messages[0].tplCodeStr,
						message_1: res.data.messages[0].message,
						recvname_1: this.nameTxtfield.value,
						failover: 'Y',
						fsubject_1: res.data.messages[0].tplCodeStr,
						fmessage_1: res.data.messages[0].message,
						button_1: res.data.messages[0].button ? res.data.messages[0].button : '[]',
						pay: this.reservedaysData.business?.id,
					}
					this.$store.dispatch('createSendMessage', sendData).then(() => {
						this.nameTxtfield.value = ''
						this.phoneTxtfield.value = ''
					})
				})
			}
		},
		// 상담수기등록시 알림톡 발송 처리
		completeSendMessage_11() {
			if (this.reservedaysData.tplCode[11]) {
				const data = {
					tplCode: this.reservedaysData.tplCode[11],
				}
				this.$store.dispatch('messages', data).then(res => {
					if (res.data.messages[0].message === undefined) {
						// 생성 / 수정시 알림톡 tpl_code가 없는 경우
						return
					} else {
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{사업지명}/g, this.reservedaysData.title)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{고객명}/g, this.nameTxtfield.value)
						res.data.messages[0].message = res.data.messages[0].message.replace(
							/#{상담완료일시}/g,
							this.$moment().format('YYYY-MM-DD HH:mm'),
						)
					}
					if (res.data.messages[0].button) {
						const buttonsData = JSON.parse(res.data.messages[0].button).button
						buttonsData.forEach(element => {
							if (element.linkMo) {
								element.linkMo = element.linkMo.replace(/#{그룹}/g, this.$route.params.code)
								element.linkPc = element.linkPc.replace(/#{그룹}/g, this.$route.params.code)
								element.linkMo = element.linkMo.replace(
									/#{코드}/g,
									this.$route.params.code === '8zuur7hjgcx' ? 'du2ct7vcb84' : this.$route.params.code,
								)
								element.linkPc = element.linkPc.replace(
									/#{코드}/g,
									this.$route.params.code === '8zuur7hjgcx' ? 'du2ct7vcb84' : this.$route.params.code,
								)
								element.linkMo = element.linkMo.replace(/#{전화번호}/g, this.direct.phoneTxtfield.value.replace(/-/g, ''))
								element.linkPc = element.linkPc.replace(/#{전화번호}/g, this.direct.phoneTxtfield.value.replace(/-/g, ''))
								element.linkMo = element.linkMo.replace(/#{고객명}/g, this.direct.nameTxtfield.value)
								element.linkPc = element.linkPc.replace(/#{고객명}/g, this.direct.nameTxtfield.value)
								element.linkMo = element.linkMo.replace(/#{상담ID}/g, this.direct.phoneTxtfield.value.replace(/-/g, ''))
								element.linkPc = element.linkPc.replace(/#{상담ID}/g, this.direct.phoneTxtfield.value.replace(/-/g, ''))
								element.linkMo = element.linkMo.replace(/#{방문ID}/g, this.direct.phoneTxtfield.value.replace(/-/g, ''))
								element.linkPc = element.linkPc.replace(/#{방문ID}/g, this.direct.phoneTxtfield.value.replace(/-/g, ''))
								element.linkMo = element.linkMo.replace(
									/#{분양정보pdf}/g,
									this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
								)
								element.linkPc = element.linkPc.replace(
									/#{분양정보pdf}/g,
									this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
								)
								if (this.reservedaysData.business.alertTalkSubscriptionInformation?.url) {
									element.linkMo = element.linkMo.replace(
										/#{청약안내pdf}/g,
										this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
									)
									element.linkPc = element.linkPc.replace(
										/#{청약안내pdf}/g,
										this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
									)
								}
								element.linkMo = element.linkMo.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
								element.linkPc = element.linkPc.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
								element.linkMo = element.linkMo.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
								element.linkPc = element.linkPc.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
								element.linkMo = element.linkMo.replace(/#{url2}/g, this.reservedaysData.business.alertTalkTalk)
								element.linkMo = element.linkMo.replace(/#{url2}/g, this.reservedaysData.business.alertTalkTalk)
							}
						})
						res.data.messages[0].button = JSON.stringify(buttonsData)
					}
					const sendData = {
						// 필수값

						code: this.$route.params.code,
						tpl_code: res.data.messages[0].tplCode,
						sender: res.data.messages[0].smssender,
						senderkey: res.data.messages[0].senderkey,
						receiver_1: this.direct.phoneTxtfield.value.replace(/-/g, ''),
						subject_1: res.data.messages[0].tplCodeStr,
						message_1: res.data.messages[0].message,
						recvname_1: this.direct.nameTxtfield.value,
						failover: 'Y',
						fsubject_1: res.data.messages[0].tplCodeStr,
						fmessage_1: res.data.messages[0].message,
						button_1: res.data.messages[0].button ? res.data.messages[0].button : '[]',
						pay: this.reservedaysData.business?.id,
					}
					this.$store.dispatch('createSendMessage', sendData).then(() => {
						this.cancelDirectwaitingDailog()
						alert('상담수기 등록이 완료되었습니다.')
					})
				})
			}
		},
		// 상담호출 재호출 전송
		createSendMessage() {
			const data = {
				tplCode: this.reservedaysData.tplCode[6],
			}
			this.$store.dispatch('messages', data).then(res => {
				if (res.data.messages[0].message === undefined) {
					// 생성 / 수정시 알림톡 tpl_code가 없는 경우
					return
				} else {
					res.data.messages[0].message = res.data.messages[0].message.replace(/#{사업지명}/g, this.reservedaysData.title)
					res.data.messages[0].message = res.data.messages[0].message.replace(/#{고객명}/g, this.nameTxtfield.value)
					res.data.messages[0].message = res.data.messages[0].message.replace(/#{대기번호}/g, this.waitingNumTxtfield.value)
					res.data.messages[0].message = res.data.messages[0].message.replace(/#{대기번호1}/g, this.waitingNumTxtfield.value)
					res.data.messages[0].message = res.data.messages[0].message.replace(/#{대기번호2}/g, this.waitingNumTxtfield.value)
					res.data.messages[0].message = res.data.messages[0].message.replace(/#{상담석번호}/g, this.$store.state.counserlorLoginData.seat)
				}
				if (res.data.messages[0].button) {
					const buttonsData = JSON.parse(res.data.messages[0].button).button
					buttonsData.forEach(element => {
						element.linkMo = element.linkMo.replace(/#{그룹}/g, this.$route.params.code)
						element.linkPc = element.linkPc.replace(/#{그룹}/g, this.$route.params.code)
						element.linkMo = element.linkMo.replace(/#{코드}/g, this.$route.params.code)
						element.linkPc = element.linkPc.replace(/#{코드}/g, this.$route.params.code)
						element.linkMo = element.linkMo.replace(/#{상담ID}/g, this.phoneTxtfield.value)
						element.linkPc = element.linkPc.replace(/#{상담ID}/g, this.phoneTxtfield.value)
						element.linkMo = element.linkMo.replace(/#{방문ID}/g, this.phoneTxtfield.value)
						element.linkPc = element.linkPc.replace(/#{방문ID}/g, this.phoneTxtfield.value)
						element.linkMo = element.linkMo.replace(
							/#{분양정보pdf}/g,
							this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
						)
						element.linkPc = element.linkPc.replace(
							/#{분양정보pdf}/g,
							this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
						)
						if (this.reservedaysData.business.alertTalkSubscriptionInformation?.url) {
							element.linkMo = element.linkMo.replace(
								/#{청약안내pdf}/g,
								this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
							)
							element.linkPc = element.linkPc.replace(
								/#{청약안내pdf}/g,
								this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
							)
						}
						element.linkMo = element.linkMo.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
						element.linkPc = element.linkPc.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
						element.linkMo = element.linkMo.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
						element.linkPc = element.linkPc.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
					})
					res.data.messages[0].button = JSON.stringify(buttonsData)
				}
				const sendData = {
					// 필수값

					code: this.$route.params.code,
					sender: res.data.messages[0].smssender,
					senderkey: res.data.messages[0].senderkey,
					tpl_code: res.data.messages[0].tplCode,
					receiver_1: this.phoneTxtfield.value,
					subject_1: res.data.messages[0].tplCodeStr,
					message_1: res.data.messages[0].message,
					recvname_1: this.nameTxtfield.value,
					failover: 'Y',
					fsubject_1: res.data.messages[0].tplCodeStr,
					fmessage_1: res.data.messages[0].message,
					button_1: res.data.messages[0].button ? res.data.messages[0].button : '[]',
					pay: this.reservedaysData.business?.id,
				}
				this.$store
					.dispatch('createSendMessage', sendData)
					.then(() => {
						this.sendAlertModal.dialog = false
					})
					.catch(() => {
						alert('알림톡 전송시 오류가 발생 하였습니다. 다시시도해 주세요.')
						this.sendAlertModal.dialog = false
					})
			})
		},
		sendAlertTalk() {
			this.sendAlertModal.dialog = true
		},
		selfAuthentication() {
			localStorage.removeItem('counserlor')
			// this.$router.push({ name: 'counselorlogin' })
			this.$router.go(-1)
			this.infoDialog.dialog = false
		},
		waitingsSocket() {
			setInterval(() => {
				const data = {
					code: this.$route.params.code,
					seat: 0,
					stat: 0,
					csdate: this.$moment(new Date()).format('YYYY-MM-DD') + 'T00:00:00.000Z',
					cedate:
						this.$moment(new Date())
							.add(1, 'days')
							.format('YYYY-MM-DD') + 'T00:00:00.000Z',
					_limit: 10,
				}
				// this.$store.dispatch('waitings', data).then(res => {
				this.$store.dispatch('waitingsConnection', data).then(res => {
					const waitingsPeople = res.data.waitingsConnection.aggregate.count
					this.waitNum = waitingsPeople
				})
				// this.realTimeWatingList = res.data.waitings
				// })
			}, 3000)
		},
		userHistory() {
			this.alertModal3.dialog = true
			this.alertModal3.name = this.nameTxtfield.value
			this.alertModal3.phone = this.phoneTxtfield.value
			this.alertModal3.waitingnum = this.waitingNumTxtfield.value
			this.alertModal3.datatable.items = this.datatable.items
			this.alertModal3.datatable.headers = this.datatable.headers
			let header = [
				{ text: '상담 날짜', value: 'cdate', width: '200px' },
				{ text: '사업지 명', value: 'title', width: '200px' },
				{ text: '상담사 아이디', value: 'counselorid', width: '200px' },
				{ text: '고객 등급', value: 'custlike', width: '200px' },
				{ text: '코멘트', value: 'recomand', width: '200px' },
				{ text: '방문 예약 날짜', value: 'rdate', width: '200px' },
			]
			let items = []
			// 사업지 중복 참여 여부
			let dupBusiness = []
			// export 항목 중복여부 data
			let dup = {}
			// excel export 항목 설정
			let exportField = {
				상담일시: 'cdate1',
				사업지명: 'title',
				'상담사 아이디': 'counselorid',
				'고객 등급': 'custlike',
				코멘트: 'recomand',
				예약일시: 'rdate1',
			}
			this.alertModal3.datatable.items.forEach((e, i) => {
				let dupIndex = dupBusiness.indexOf(e.code)
				if (dupIndex === -1) {
					dupBusiness.push(e.code)
				}
				// if (e.fileUpload.length !== 0) {
				// 	header = [
				// 		{ text: '상담 날짜', value: 'cdate' },
				// 		{ text: '상담사 아이디', value: 'counselorid' },
				// 		{ text: '고객 등급', value: 'custlike' },
				// 		{ text: '코멘트', value: 'recomand' },
				// 		{ text: '방문 예약 날짜', value: 'rdate' },
				// 		{ text: '이미지 첨부', value: 'imgUpload', width: '200px', align: 'center' },
				// 	]
				// }
				// 예약 목록으로 해당 방문예약 호출
				let item = {}
				let data1 = {
					code: e.code,
				}
				let status1
				if (e.status === null || e.status === 1) {
					status1 = '방문 예약'
				} else if (e.status === 2) {
					status1 = '예약 취소'
				}
				item.status = e.status
				item.status1 = status1

				let ismarketing
				let ispersonal
				if (e.ismarketing === 1) {
					ismarketing = 'Y'
				} else if (e.ismarketing === 2) {
					ismarketing = 'N'
				}
				if (e.ispersonal === 1) {
					ispersonal = 'Y'
				} else if (e.ispersonal === 2) {
					ispersonal = 'N'
				}

				item.ismarketing1 = ismarketing
				item.ispersonal1 = ispersonal

				this.$store
					.dispatch('reservedays', data1)
					.then(res => {
						//방문예약의 inputbox 정보 저장
						e.categories = res.data.reservedays[0].input_box.categories
						e.categories.forEach(a => {
							// inputbox type이 약관이 경우

							if (a.type === 90) {
								let ismarketing
								let ispersonal
								if (e.ismarketing === 1) {
									ismarketing = 'Y'
								} else if (e.ismarketing === 2) {
									ismarketing = 'N'
								}
								if (e.ispersonal === 1) {
									ispersonal = 'Y'
								} else if (e.ispersonal === 2) {
									ispersonal = 'N'
								}

								item.ismarketing1 = ismarketing
								item.ispersonal1 = ispersonal
							} else if (a.type === 31 || a.type === 30) {
								// type 날짜일 경우 예약일시 적용
							} else {
								//  inputbox type이 약관,날짜 아닐 경우 header 저장
								if (a.type !== 21) {
									if (dupIndex === -1) {
										header.push({
											text: a.codename,
											value: a.code + i,
											width: '200',
										})
										/// export key, value 설정
										if (a.codename in exportField) {
											let dupKey = a.codename + '(' + dup[a.codename] + ')'
											exportField[dupKey] = a.code + i
											dup[a.codename] += 1
										} else {
											dup[a.codename] = 1
											exportField[a.codename] = a.code + i
										}

										if (a.type === 11) {
											e[this.changeTypeText(a.type)].split('/').forEach(type => {
												if (type.split(':')[0] === a.code) {
													let checkItem = []
													type
														.split(':')[1]
														.split(',')
														.forEach(detailCode => {
															if (detailCode) {
																let valIndex = a.category_details.findIndex(x => x.detailcode === detailCode)
																let value
																if (a.category_details[valIndex] !== undefined) {
																	value = a.category_details[valIndex].detailname
																	checkItem.push(value)
																}
															}
														})
													item[type.split(':')[0] + i] = checkItem.toString()
												}
											})
										} else if (a.type === 10) {
											e[this.changeTypeText(a.type)].split('/').forEach(type => {
												if (type.split(':')[0] === a.code && type.split(':')[1]) {
													let valIndex = a.category_details.findIndex(x => x.detailcode === type.split(':')[1])
													let value
													if (a.category_details[valIndex] !== undefined) {
														value = a.category_details[valIndex].detailname

														if (value === '기타') {
															let etc = e.etc.split('/')
															let etcIndex = etc.findIndex(e => e.indexOf(type.split(':')[1]) !== -1)

															item[type.split(':')[0] + i] = etc[etcIndex].split(':')[1]
														} else {
															item[type.split(':')[0] + i] = value
														}
													}
												}
											})
										} else if (a.type === 12) {
											e[this.changeTypeText(a.type)].split('/').forEach(type => {
												if (type.split(':')[0] === a.code) {
													item[type.split(':')[0] + i] = type.split(':')[1]
												}
											})
										} else if (a.type === 20) {
											e[this.changeTypeText(a.type)].split('/').forEach(type => {
												if (type.split(':')[0] === a.code) {
													item[type.split(':')[0] + i] = type.split(':')[1]
												}
											})
										}
									} else {
										if (a.type === 11) {
											e[this.changeTypeText(a.type)].split('/').forEach(type => {
												if (type.split(':')[0] === a.code) {
													let checkItem = []
													type
														.split(':')[1]
														.split(',')
														.forEach(detailCode => {
															if (detailCode) {
																let valIndex = a.category_details.findIndex(x => x.detailcode === detailCode)
																let value
																if (a.category_details[valIndex] !== undefined) {
																	value = a.category_details[valIndex].detailname
																	checkItem.push(value)
																}
															}
														})
													item[type.split(':')[0] + dupIndex] = checkItem.toString()
												}
											})
										} else if (a.type === 10) {
											e[this.changeTypeText(a.type)].split('/').forEach(type => {
												if (type.split(':')[0] === a.code && type.split(':')[1]) {
													let valIndex = a.category_details.findIndex(x => x.detailcode === type.split(':')[1])
													let value
													if (a.category_details[valIndex] !== undefined) {
														value = a.category_details[valIndex].detailname
														if (value === '기타') {
															let etc = e.etc.split('/')
															let etcIndex = etc.findIndex(e => e.indexOf(type.split(':')[1]) !== -1)

															item[type.split(':')[0] + dupIndex] = etc[etcIndex].split(':')[1]
														} else {
															item[type.split(':')[0] + dupIndex] = value
														}
													}
												}
											})
										} else if (a.type === 12) {
											e[this.changeTypeText(a.type)].split('/').forEach(type => {
												if (type.split(':')[0] === a.code) {
													item[type.split(':')[0] + dupIndex] = type.split(':')[1]
												}
											})
										} else if (a.type === 20) {
											e[this.changeTypeText(a.type)].split('/').forEach(type => {
												if (type.split(':')[0] === a.code) {
													item[type.split(':')[0] + dupIndex] = type.split(':')[1]
												}
											})
										}
									}
								}
								// else if (a.type === 21) {
								// 	let images = []
								// 	const url = this.$store.state.backServer
								// 	e.fileUpload.forEach(x => {
								// 		images.push(url + x.url)
								// 	})

								// 	item['imgUpload'] = images
								// }
							}
						})

						//사업지명,등록일시 삽입
						item.title = e.title
						item.cdate = e.cdate
						item.counselorid = e.counselorid
						item.custlike = e.custlike
						item.recomand = e.recomand
						item.rdate = e.rdate

						// item.item.updated_at = this.$moment(e.updated_at).format('YYYY-MM-DD HH:mm:ss')
						// if (e.rdate) {
						// 	item.rdate = this.$moment(e.rdate).format('YYYY-MM-DD HH:mm:ss')
						// }
						if (e.rdate) {
							item.rdate = this.$moment(e.rdate).format('YYYY-MM-DD HH:mm:ss')
							item.rdate1 = this.$moment(e.rdate)
								.subtract(18, 'hours')
								.format('YYYY-MM-DD HH:mm:ss')
						}
						item.cdate1 = this.$moment(e.cdate)
							.subtract(9, 'hours')
							.format('YYYY-MM-DD HH:mm:ss')
						items.push(item)
					})
					.catch(() => {})
				this.alertModal3.datatable.headers = header
				this.alertModal3.datatable.items = items
				this.alertModal3.json_fields = exportField
			})
		},

		userExport() {
			document.getElementById(this.alertModal3.phone).click()
		},
		callWaitingData() {
			this.$store.state.loading = true
			const data = {
				code: this.$route.params.code,
			}
			this.$store.dispatch('reservedays', data).then(res => {
				this.$store.state.reservedayInputBox = res.data.reservedays[0].input_box
				const data = {
					id: localStorage.getItem('waitingId'),
					code: this.$route.params.code,
				}
				this.$store
					.dispatch('waitings', data)
					.then(res => {
						let sorted = res.data.waitings.sort((a, b) => {
							if (a.waitingnum > b.waitingnum) return 1
							if (a.waitingnum === b.waitingnum) return 0
							if (a.waitingnum < b.waitingnum) return -1
						})
						this.counseringData = sorted[0]
						this.nameTxtfield.value = sorted[0].name
						this.phoneTxtfield.value = sorted[0].phone
						this.waitingNumTxtfield.value = String(sorted[0].waitingnum)
						if (sorted[0].ispersonal === 1) {
							this.check1.value = true
						} else {
							this.check3.value = true
						}
						if (sorted[0].ismarketing === 1) {
							this.check2.value = true
						} else {
							this.check3.value = true
						}
						this.$store.state.reserveusersData = sorted[0]
						if (this.$store.state.reservedayInputBox.categories.length > 0) {
							this.$store.state.reservedayInputBox.categories.forEach(element => {
								if (element.type === 11) {
									if (sorted[0][this.changeTypeText(element.type)]) {
										sorted[0][this.changeTypeText(element.type)].split('/').forEach(type => {
											if (type.split(':')[0] === element.code) {
												type
													.split(':')[1]
													.split(',')
													.forEach((detailCode, index) => {
														element.items[index].value = detailCode
													})
											}
										})
									}
								} else if (element.type === 10) {
									if (sorted[0][this.changeTypeText(element.type)]) {
										let etcArr = [] // 기타 값 임시저장
										let foundIdx
										if (sorted[0].etc !== null) {
											sorted[0].etc.split('/').forEach(el => {
												etcArr.push(el.split(':'))
											})
										}

										sorted[0][this.changeTypeText(element.type)].split('/').forEach(type => {
											if (type.split(':')[0] === element.code) {
												element.value = type.split(':')[1]
											}
										})

										element.items = { value: '', maxlength: '200', outlined: true, autofocus: false, hideDetail: true, errorMessage: '' }
										element.nowRadioValue = ''
										// 기타 선택지 값 삽입
										foundIdx = etcArr.findIndex(x => x[0] === element.value)
										if (foundIdx !== -1) {
											element.etc = etcArr[foundIdx][1]
										}
									}
								} else if (element.type === 12) {
									if (sorted[0][this.changeTypeText(element.type)]) {
										sorted[0][this.changeTypeText(element.type)].split('/').forEach(type => {
											if (type.split(':')[0] === element.code) {
												element.items.value = type.split(':')[1]
											}
										})
									}
								} else if (element.type === 20) {
									if (sorted[0][this.changeTypeText(element.type)]) {
										sorted[0][this.changeTypeText(element.type)].split('/').forEach(type => {
											if (type.split(':')[0] === element.code) {
												element.items.value = type.split(':')[1]
											}
										})
									}
								}
							})
						}
						this.waitingId = sorted[0].id
						const setData = this.$store.state.reservedayInputBox
						this.$store.commit('reservedayInputBox', {})
						setTimeout(() => {
							this.$store.state.loading = false
							this.$store.commit('reservedayInputBox', setData)
						}, 500)
					})
					.catch(err => {
						console.log({ err })
						this.$store.state.loading = false
						localStorage.removeItem('waitingId')
						alert('오류가 발생하였습니다. 관리자에게 문의하세요!')
					})
			})
		},
		counselors(counselorid) {
			const data = {
				counselorid: counselorid,
				business: this.$route.params.biz,
				code: this.$route.params.code,
			}
			this.$store
				.dispatch('counselors', data)
				.then(res => {
					this.infoDialog.name = res.data.counselors[0].name
					this.infoDialog.seat = res.data.counselors[0].seat
					this.$store.state.counserlorLoginData = res.data.counselors[0]
					// localStorage 에 상담중이던 waitings data가 남아있는 경우 해당 데이터 불러옴
					if (
						localStorage.getItem('waitingId') !== null &&
						localStorage.getItem('counselingIdNow') === this.$store.state.counserlorLoginData.counselorid
					) {
						this.callWaitingData()
					}
				})
				.catch(() => {})
		},
		trackingCodes(phone) {
			this.$store.dispatch('waitings', { phone: phone }).then(resWaiting => {
				const waitings = resWaiting.data.waitings
				let historyItem = []
				historyItem = waitings.filter(item => {
					return item.stat !== 0
				})
				waitings.forEach(e => {
					e.rdate = this.$moment(e.rdate)
						.add(9, 'hours')
						.format('YYYY-MM-DD HH:mm')
				})
				this.datatable.items = historyItem
			})
			// this.datatable.items.splice(0, 1)
		},
		// 상담호출 메세지 전송
		callMessage(reserveuser) {
			const data = {
				tplCode: this.reservedaysData.tplCode[6],
			}
			this.$store
				.dispatch('messages', data)
				.then(res => {
					if (res.data.messages[0].message === undefined) {
						// 생성 / 수정시 알림톡 tpl_code가 없는 경우
						return
					} else {
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{사업지명}/g, this.reservedaysData.title)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{고객명}/g, reserveuser.name)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{대기번호}/g, reserveuser.waitingnum)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{대기번호1}/g, reserveuser.waitingnum)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{대기번호2}/g, reserveuser.waitingnum)
						res.data.messages[0].message = res.data.messages[0].message.replace(
							/#{상담석번호}/g,
							this.$store.state.counserlorLoginData.seat,
						)
					}
					if (res.data.messages[0].button) {
						const buttonsData = JSON.parse(res.data.messages[0].button).button
						buttonsData.forEach(element => {
							element.linkMo = element.linkMo.replace(/#{그룹}/g, this.$route.params.code)
							element.linkPc = element.linkPc.replace(/#{그룹}/g, this.$route.params.code)
							element.linkMo = element.linkMo.replace(/#{코드}/g, this.$route.params.code)
							element.linkPc = element.linkPc.replace(/#{코드}/g, this.$route.params.code)
							element.linkMo = element.linkMo.replace(/#{상담ID}/g, this.phoneTxtfield.value)
							element.linkPc = element.linkPc.replace(/#{상담ID}/g, this.phoneTxtfield.value)
							element.linkMo = element.linkMo.replace(/#{방문ID}/g, this.phoneTxtfield.value)
							element.linkPc = element.linkPc.replace(/#{방문ID}/g, this.phoneTxtfield.value)
							element.linkMo = element.linkMo.replace(
								/#{분양정보pdf}/g,
								this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
							)
							element.linkPc = element.linkPc.replace(
								/#{분양정보pdf}/g,
								this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
							)
							if (this.reservedaysData.business.alertTalkSubscriptionInformation?.url) {
								element.linkMo = element.linkMo.replace(
									/#{청약안내pdf}/g,
									this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
								)
								element.linkPc = element.linkPc.replace(
									/#{청약안내pdf}/g,
									this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
								)
							}
							element.linkMo = element.linkMo.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
							element.linkPc = element.linkPc.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
							element.linkMo = element.linkMo.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
							element.linkPc = element.linkPc.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
						})
						res.data.messages[0].button = JSON.stringify(buttonsData)
					}
					const sendData = {
						// 필수값

						code: this.$route.params.code,
						tpl_code: res.data.messages[0].tplCode,
						sender: res.data.messages[0].smssender,
						senderkey: res.data.messages[0].senderkey,
						receiver_1: reserveuser.phone,
						subject_1: res.data.messages[0].tplCodeStr,
						message_1: res.data.messages[0].message,
						// 여기까지 필수값
						recvname_1: reserveuser.name,
						failover: 'Y',
						fsubject_1: res.data.messages[0].tplCodeStr,
						fmessage_1: res.data.messages[0].message,
						button_1: res.data.messages[0].button ? res.data.messages[0].button : '[]',
						pay: this.reservedaysData.business?.id,
					}
					this.$store
						.dispatch('createSendMessage', sendData)
						.then(async () => {
							// for (let index = 0; index < 5; index++) {
							// await this.findTargetPreCall(reserveuser.waitingnum, 1)
							// if (this.$route.params.code === 'g889daer0a') await this.findTargetPreCall(reserveuser.waitingnum + 9, 9)
							// else await this.findTargetPreCall(reserveuser.waitingnum + 4, 4)
							// }
							// 대기알림 삭제 - 21. 10.24 - 이규화
							// this.findTargetStandby(reserveuser.waitingnum)
						})
						.catch(() => {})
				})
				.catch(() => {})
		},
		// 대기 알림 보낼 사람 찾기
		findTargetStandby(nowNumber) {
			const data = {
				code: this.$route.params.code,
				stat: 0,
			}
			this.$store
				.dispatch('waitings', data)
				.then(res => {
					const add5numberIndex = res.data.waitings.findIndex(x => {
						return x.waitingnum === nowNumber + 5
					})
					const add10numberIndex = res.data.waitings.findIndex(x => {
						return x.waitingnum === nowNumber + 10
					})
					const add15numberIndex = res.data.waitings.findIndex(x => {
						return x.waitingnum === nowNumber + 15
					})
					const add20numberIndex = res.data.waitings.findIndex(x => {
						return x.waitingnum === nowNumber + 20
					})
					const add25numberIndex = res.data.waitings.findIndex(x => {
						return x.waitingnum === nowNumber + 25
					})
					// 대기번호 현재번호 +25 까지 대기자알림 보냄
					if (res.data.waitings.length > 5 && add5numberIndex !== -1) {
						this.standbyMessage(res.data.waitings[add5numberIndex], 4)
					} else if (res.data.waitings.length > 10 && add10numberIndex !== -1) {
						this.standbyMessage(res.data.waitings[add5numberIndex], 4)
						this.standbyMessage(res.data.waitings[add10numberIndex], 9)
					} else if (res.data.waitings.length > 15 && add15numberIndex !== -1) {
						this.standbyMessage(res.data.waitings[add5numberIndex], 4)
						this.standbyMessage(res.data.waitings[add10numberIndex], 9)
						this.standbyMessage(res.data.waitings[add15numberIndex], 14)
					} else if (res.data.waitings.length > 20 && add20numberIndex !== -1) {
						this.standbyMessage(res.data.waitings[add5numberIndex], 4)
						this.standbyMessage(res.data.waitings[add10numberIndex], 9)
						this.standbyMessage(res.data.waitings[add15numberIndex], 14)
						this.standbyMessage(res.data.waitings[add20numberIndex], 19)
					} else if (res.data.waitings.length > 25 && add25numberIndex !== -1) {
						this.standbyMessage(res.data.waitings[add5numberIndex], 4)
						this.standbyMessage(res.data.waitings[add10numberIndex], 9)
						this.standbyMessage(res.data.waitings[add15numberIndex], 14)
						this.standbyMessage(res.data.waitings[add20numberIndex], 19)
						this.standbyMessage(res.data.waitings[add25numberIndex], 24)
					}
				})
				.catch(() => {})
		},
		// 대기 알림 전송
		standbyMessage(targetdata, frontNum) {
			const data = {
				tplCode: this.reservedaysData.tplCode[4],
			}
			this.$store
				.dispatch('messages', data)
				.then(res => {
					if (res.data.messages[0].message === undefined) {
						// 생성 / 수정시 알림톡 tpl_code가 없는 경우
						return
					} else {
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{사업지명}/g, this.reservedaysData.title)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{고객명}/g, targetdata.name)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{대기번호}/g, targetdata.waitingnum)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{대기번호1}/g, targetdata.waitingnum)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{대기번호2}/g, targetdata.waitingnum)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{대기자수}/g, frontNum)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{내앞대기자수}/g, frontNum)
					}
					if (res.data.messages[0].button) {
						const buttonsData = JSON.parse(res.data.messages[0].button).button
						buttonsData.forEach(element => {
							element.linkMo = element.linkMo.replace(/#{그룹}/g, this.$route.params.code)
							element.linkPc = element.linkPc.replace(/#{그룹}/g, this.$route.params.code)
							element.linkMo = element.linkMo.replace(/#{코드}/g, this.$route.params.code)
							element.linkPc = element.linkPc.replace(/#{코드}/g, this.$route.params.code)
							element.linkMo = element.linkMo.replace(/#{상담ID}/g, this.phoneTxtfield.value)
							element.linkPc = element.linkPc.replace(/#{상담ID}/g, this.phoneTxtfield.value)
							element.linkMo = element.linkMo.replace(/#{방문ID}/g, this.phoneTxtfield.value)
							element.linkPc = element.linkPc.replace(/#{방문ID}/g, this.phoneTxtfield.value)
							element.linkMo = element.linkMo.replace(
								/#{분양정보pdf}/g,
								this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
							)
							element.linkPc = element.linkPc.replace(
								/#{분양정보pdf}/g,
								this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
							)
							if (this.reservedaysData.business.alertTalkSubscriptionInformation?.url) {
								element.linkMo = element.linkMo.replace(
									/#{청약안내pdf}/g,
									this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
								)
								element.linkPc = element.linkPc.replace(
									/#{청약안내pdf}/g,
									this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
								)
							}
							element.linkMo = element.linkMo.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
							element.linkPc = element.linkPc.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
							element.linkMo = element.linkMo.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
							element.linkPc = element.linkPc.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
						})
						res.data.messages[0].button = JSON.stringify(buttonsData)
					}
					const sendData = {
						// 필수값

						code: this.$route.params.code,
						sender: res.data.messages[0].smssender,
						senderkey: res.data.messages[0].senderkey,
						tpl_code: res.data.messages[0].tplCode,
						receiver_1: targetdata.phone,
						subject_1: res.data.messages[0].tplCodeStr,
						message_1: res.data.messages[0].message,
						// 여기까지 필수값
						recvname_1: targetdata.name,
						failover: 'Y',
						fsubject_1: res.data.messages[0].tplCodeStr,
						fmessage_1: res.data.messages[0].message,
						button_1: res.data.messages[0].button ? res.data.messages[0].button : '[]',
						pay: this.reservedaysData.business?.id,
					}
					this.$store
						.dispatch('createSendMessage', sendData)
						.then(() => {})
						.catch(() => {})
				})
				.catch(() => {})
		},
		// 내앞대기자 알림 보낼 사람 찾기
		async findTargetPreCall(waitingnum, num) {
			const data = {
				code: this.$route.params.code,
				waitingnum: waitingnum + 1,
				stat: 0,
				rsdate:
					this.$moment(new Date())
						.subtract(1, 'd')
						.format('YYYY-MM-DD') + 'T15:00:00.000Z',
			}
			await this.$store.dispatch('waitings', data).then(async resWa => {
				if (resWa.data.waitings[0]) {
					// const data = {
					//
					// 	code: this.$route.params.code,
					// 	tpl_code: this.reservedaysData.tplCode[4],
					// 	receiver_1: resWa.data.waitings[0].phone,
					// 	created_at_gte: this.$moment().subtract('hours', 1)._d,
					// }
					// await this.$store.dispatch('sendMessages', data).then(async resMs => {
					// if (resMs.data.sendMessages.length === 0) {
					const data = {
						tplCode: this.reservedaysData.tplCode[4],
					}
					await this.$store
						.dispatch('messages', data)
						.then(async res => {
							const targetdata = resWa.data.waitings[0]
							let bookday
							bookday = this.$moment(targetdata.cdate)
								.subtract(9, 'hours')
								.format('YYYY-MM-DD HH:mm')
							// setTimeout(() => {
							let messageData = JSON.parse(JSON.stringify(res.data.messages[0]))
							messageData.message = messageData.message.replace(/#{사업지명}/g, this.reservedaysData.title)
							messageData.message = messageData.message.replace(/#{고객명}/g, targetdata.name)
							messageData.message = messageData.message.replace(/#{대기번호}/g, targetdata.waitingnum)
							messageData.message = messageData.message.replace(/#{대기번호1}/g, targetdata.waitingnum)
							messageData.message = messageData.message.replace(/#{대기번호2}/g, targetdata.waitingnum)
							messageData.message = messageData.message.replace(/#{상담신청일시}/g, bookday)
							messageData.message = messageData.message.replace(/#{대기자수}/g, num)
							messageData.message = messageData.message.replace(/#{내앞대기자수}/g, num)
							if (res.data.messages[0].button) {
								const buttonsData = JSON.parse(res.data.messages[0].button).button
								buttonsData.forEach(element => {
									element.linkMo = element.linkMo.replace(/#{그룹}/g, this.$route.params.code)
									element.linkPc = element.linkPc.replace(/#{그룹}/g, this.$route.params.code)
									element.linkMo = element.linkMo.replace(/#{코드}/g, this.$route.params.code)
									element.linkPc = element.linkPc.replace(/#{코드}/g, this.$route.params.code)
									element.linkMo = element.linkMo.replace(/#{전화번호}/g, targetdata.phone)
									element.linkPc = element.linkPc.replace(/#{전화번호}/g, targetdata.phone)
									element.linkMo = element.linkMo.replace(/#{상담ID}/g, targetdata.phone)
									element.linkPc = element.linkPc.replace(/#{상담ID}/g, targetdata.phone)
									element.linkMo = element.linkMo.replace(/#{방문ID}/g, targetdata.phone)
									element.linkPc = element.linkPc.replace(/#{방문ID}/g, targetdata.phone)
									element.linkMo = element.linkMo.replace(
										/#{분양정보pdf}/g,
										this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
									)
									element.linkPc = element.linkPc.replace(
										/#{분양정보pdf}/g,
										this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
									)
									if (this.reservedaysData.business.alertTalkSubscriptionInformation?.url) {
										element.linkMo = element.linkMo.replace(
											/#{청약안내pdf}/g,
											this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
										)
										element.linkPc = element.linkPc.replace(
											/#{청약안내pdf}/g,
											this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
										)
									}
									element.linkMo = element.linkMo.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
									element.linkPc = element.linkPc.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
									element.linkMo = element.linkMo.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
									element.linkPc = element.linkPc.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
								})
								res.data.messages[0].button = JSON.stringify(buttonsData)
							}
							const sendData = {
								// 필수값

								code: this.$route.params.code,
								sender: res.data.messages[0].smssender,
								senderkey: res.data.messages[0].senderkey,
								tpl_code: res.data.messages[0].tplCode,
								receiver_1: targetdata.phone,
								subject_1: res.data.messages[0].tplCodeStr,
								message_1: messageData.message,
								// 여기까지 필수값
								recvname_1: targetdata.name,
								failover: 'Y',
								fsubject_1: res.data.messages[0].tplCodeStr,
								fmessage_1: messageData.message,
								button_1: res.data.messages[0].button ? res.data.messages[0].button : '[]',
								pay: this.reservedaysData.business?.id,
							}
							this.$store
								.dispatch('createSendMessage', sendData)
								.then(() => {})
								.catch(() => {})
							// }, 500 * index)
						})
						.catch(err => {
							console.log({ err })
						})
					// }
					// })
				}
			})
		},
		// 내앞대기자 알림톡 전송
		async preCallMessage(targetdata) {
			const data = {
				tplCode: this.reservedaysData.tplCode[4],
			}
			await this.$store
				.dispatch('messages', data)
				.then(res => {
					let bookday
					if (targetdata === undefined) {
						return
					} else {
						bookday = this.$moment(targetdata.cdate)
							.subtract(9, 'hours')
							.format('YYYY-MM-DD HH:mm')
					}
					if (res.data.messages[0].message === undefined) {
						// 생성 / 수정시 알림톡 tpl_code가 없는 경우
						return
					} else {
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{사업지명}/g, this.reservedaysData.title)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{고객명}/g, targetdata.name)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{대기번호}/g, targetdata.waitingnum)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{대기번호1}/g, targetdata.waitingnum)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{대기번호2}/g, targetdata.waitingnum)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{상담신청일시}/g, bookday)
					}
					if (res.data.messages[0].button) {
						const buttonsData = JSON.parse(res.data.messages[0].button).button
						buttonsData.forEach(element => {
							element.linkMo = element.linkMo.replace(/#{그룹}/g, this.$route.params.code)
							element.linkPc = element.linkPc.replace(/#{그룹}/g, this.$route.params.code)
							element.linkMo = element.linkMo.replace(/#{코드}/g, this.$route.params.code)
							element.linkPc = element.linkPc.replace(/#{코드}/g, this.$route.params.code)
							element.linkMo = element.linkMo.replace(/#{전화번호}/g, targetdata.phone)
							element.linkPc = element.linkPc.replace(/#{전화번호}/g, targetdata.phone)
							element.linkMo = element.linkMo.replace(/#{상담ID}/g, targetdata.phone)
							element.linkPc = element.linkPc.replace(/#{상담ID}/g, targetdata.phone)
							element.linkMo = element.linkMo.replace(/#{방문ID}/g, targetdata.phone)
							element.linkPc = element.linkPc.replace(/#{방문ID}/g, targetdata.phone)
							element.linkMo = element.linkMo.replace(
								/#{분양정보pdf}/g,
								this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
							)
							element.linkPc = element.linkPc.replace(
								/#{분양정보pdf}/g,
								this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
							)
							if (this.reservedaysData.business.alertTalkSubscriptionInformation?.url) {
								element.linkMo = element.linkMo.replace(
									/#{청약안내pdf}/g,
									this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
								)
								element.linkPc = element.linkPc.replace(
									/#{청약안내pdf}/g,
									this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
								)
							}
							element.linkMo = element.linkMo.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
							element.linkPc = element.linkPc.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
							element.linkMo = element.linkMo.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
							element.linkPc = element.linkPc.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
						})
						res.data.messages[0].button = JSON.stringify(buttonsData)
					}
					const sendData = {
						// 필수값

						code: this.$route.params.code,
						tpl_code: res.data.messages[0].tplCode,
						sender: res.data.messages[0].smssender,
						senderkey: res.data.messages[0].senderkey,
						receiver_1: targetdata.phone,
						subject_1: res.data.messages[0].tplCodeStr,
						message_1: res.data.messages[0].message,
						// 여기까지 필수값
						recvname_1: targetdata.name,
						failover: 'Y',
						fsubject_1: res.data.messages[0].tplCodeStr,
						fmessage_1: res.data.messages[0].message,
						button_1: res.data.messages[0].button ? res.data.messages[0].button : '[]',
						pay: this.reservedaysData.business?.id,
					}
					this.$store
						.dispatch('createSendMessage', sendData)
						.then(() => {})
						.catch(() => {})
				})
				.catch(() => {})
		},
		// 미처리 메세지 전송
		unattendedMessage(reserveuser) {
			const data = {
				tplCode: this.reservedaysData.tplCode[7],
			}
			this.$store
				.dispatch('messages', data)
				.then(res => {
					let reserveDayurl = `${location.protocol}//${location.hostname}/reserve_day/${this.$route.params.code}`
					const bookday = this.$moment(reserveuser.created_at).format('YYYY년MM월DD일 HH:mm')
					if (res.data.messages[0].message === undefined) {
						// 생성 / 수정시 알림톡 tpl_code가 없는 경우
						return
					} else {
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{사업지명}/g, this.reservedaysData.title)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{고객명}/g, reserveuser.name)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{상담신청일시}/g, bookday)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{예약URL}/g, reserveDayurl)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{그룹}/g, this.$route.params.code)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{코드}/g, this.$route.params.code)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{방문ID}/g, reserveuser.phone)
						res.data.messages[0].message = res.data.messages[0].message.replace(/#{상담ID}/g, reserveuser.phone)
					}
					if (res.data.messages[0].button) {
						const buttonsData = JSON.parse(res.data.messages[0].button).button
						buttonsData.forEach(element => {
							element.linkMo = element.linkMo.replace(/#{그룹}/g, this.$route.params.code)
							element.linkPc = element.linkPc.replace(/#{그룹}/g, this.$route.params.code)
							element.linkMo = element.linkMo.replace(/#{코드}/g, this.$route.params.code)
							element.linkPc = element.linkPc.replace(/#{코드}/g, this.$route.params.code)
							element.linkMo = element.linkMo.replace(/#{상담ID}/g, reserveuser.phone)
							element.linkPc = element.linkPc.replace(/#{상담ID}/g, reserveuser.phone)
							element.linkMo = element.linkMo.replace(/#{방문ID}/g, reserveuser.phone)
							element.linkPc = element.linkPc.replace(/#{방문ID}/g, reserveuser.phone)
							element.linkMo = element.linkMo.replace(
								/#{분양정보pdf}/g,
								this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
							)
							element.linkPc = element.linkPc.replace(
								/#{분양정보pdf}/g,
								this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
							)
							if (this.reservedaysData.business.alertTalkSubscriptionInformation?.url) {
								element.linkMo = element.linkMo.replace(
									/#{청약안내pdf}/g,
									this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
								)
								element.linkPc = element.linkPc.replace(
									/#{청약안내pdf}/g,
									this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
								)
							}
							element.linkMo = element.linkMo.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
							element.linkPc = element.linkPc.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
							element.linkMo = element.linkMo.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
							element.linkPc = element.linkPc.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
						})
						res.data.messages[0].button = JSON.stringify(buttonsData)
					}
					const sendData = {
						// 필수값

						code: this.$route.params.code,
						sender: res.data.messages[0].smssender,
						senderkey: res.data.messages[0].senderkey,
						tpl_code: res.data.messages[0].tplCode,
						receiver_1: reserveuser.phone,
						subject_1: res.data.messages[0].tplCodeStr,
						message_1: res.data.messages[0].message,
						// 여기까지 필수값
						recvname_1: reserveuser.name,
						failover: 'Y',
						fsubject_1: res.data.messages[0].tplCodeStr,
						fmessage_1: res.data.messages[0].message,
						button_1: res.data.messages[0].button ? res.data.messages[0].button : '[]',
						pay: this.reservedaysData.business?.id,
					}
					this.$store
						.dispatch('createSendMessage', sendData)
						.then(() => {})
						.catch(() => {})
				})
				.catch(() => {})
		},
		complete(type) {
			if (!this.$store.state.counselor_reserve) return alert('담당자를 선택해 주세요.')
			if (this.userLists.filter(x => String(x.id) === String(this.$store.state.counselor_reserve)).length === 0)
				return alert('담당자를 선택해 주세요.')

			const userData = this.userLists.filter(x => String(x.id) === String(this.$store.state.counselor_reserve))[0]

			let ok = 0
			if (!type) {
				if (this.radios.radioSelected === '') {
					this.alertModal2.dialog = true
					this.alertModal2.text = '고객 성향을 선택해 주세요.'
					ok += 1
				}
			}
			// if (this.check1.value && !this.check2.value) {
			// 	this.alertModal2.dialog = true
			// 	this.alertModal2.text = '분양정보 제공 및 마케팅 활용 동의를 체크해 주세요.'
			// 	ok += 1
			// }
			// if (!this.check1.value && this.check2.value) {
			// 	this.alertModal2.dialog = true
			// 	this.alertModal2.text = '개인정보 수집동의를 체크해 주세요.'
			// 	ok += 1
			// }
			const checkBox = []
			const checkone = []
			const textfiled = []
			let userDataInput = []
			let sex = null
			let realname = null
			let age = null
			let qualification = null
			let homeOwnership = null
			let bankBook = null
			let purpose = null
			let subscribe = null
			let floor = null
			let houseAcreage = null
			let acreageUnit = null
			let location = null
			let locationType = null
			this.$store.state.reservedayInputBox.categories.forEach(obj => {
				if (obj.tag === 'name') {
					realname = obj.items.value
				} else if (obj.tag === 'age') {
					if (obj.category_details.length > 0 && obj.value)
						age = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'sex') {
					if (obj.category_details.length > 0 && obj.value)
						sex = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'qualification') {
					if (obj.category_details.length > 0 && obj.value)
						qualification = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'homeOwnership') {
					if (obj.category_details.length > 0 && obj.value)
						homeOwnership = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'bankBook') {
					if (obj.category_details.length > 0 && obj.value)
						bankBook = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'purpose') {
					if (obj.category_details.length > 0 && obj.value)
						purpose = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'subscribe') {
					if (obj.category_details.length > 0 && obj.value)
						subscribe = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'floor') {
					if (obj.category_details.length > 0 && obj.value)
						floor = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
				} else if (obj.tag === 'houseAcreage') {
					if (obj.category_details.length > 0 && obj.value) {
						houseAcreage = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
						acreageUnit = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].etc
					}
				} else if (obj.tag === 'locationType') {
					if (obj.category_details.length > 0 && obj.value) {
						location = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].detailname
						locationType = obj.category_details[obj.category_details.map(x => x.detailcode).indexOf(obj.value)].etc
					}
				}
				if (obj.type === 10) {
					checkone.push(obj.code + ':' + obj.value)
				} else if (obj.type === 11) {
					checkBox.push(obj.code + ':' + obj.items.map(x => x.value).join(','))
				} else if (obj.type === 12) {
					checkone.push(obj.code + ':' + obj.items.value)
				} else if (obj.type === 20) {
					textfiled.push(obj.code + ':' + obj.items.value)
				}
				if (obj.type === 10) {
					userDataInput.push({
						musthave: obj.musthave,
						explain: obj.explain,
						code: obj.code,
						codename: obj.codename,
						contents: obj.contents,
						tag: obj.tag,
						type: obj.type,
						qusType: '객관식(단일선택)',
						category_details: obj.category_details,
						value:
							obj.category_details.filter(x => x.detailcode === obj.value).length > 0
								? obj.category_details.filter(x => x.detailcode === obj.value)[0].detailname
								: '무응답',
						reserveGroupCode: this.$route.params.subCode,
					})
				} else if (obj.type === 11) {
					userDataInput.push({
						musthave: obj.musthave,
						explain: obj.explain,
						code: obj.code,
						codename: obj.codename,
						contents: obj.contents,
						tag: obj.tag,
						type: obj.type,
						qusType: '객관식(다중선택)',
						category_details: obj.category_details,
						value:
							obj.items.filter(x => x.value !== '').length > 0
								? obj.items
										.filter(x => x.value !== '')
										.map(x => x.label)
										.join(',')
								: '무응답',
						reserveGroupCode: this.$route.params.subCode,
					})
				} else if (obj.tag === 'location') {
					userDataInput.push({
						musthave: obj.musthave,
						explain: obj.explain,
						code: obj.code,
						codename: obj.codename,
						contents: obj.contents,
						tag: obj.tag,
						type: obj.type,
						qusType: '지역',
						category_details: obj.category_details,
						value:
							this.$store.state.searchsel_city1.value +
							'_' +
							this.$store.state.searchsel_city2.value +
							'_' +
							this.$store.state.searchsel_city3.value,
						reserveGroupCode: this.$route.params.subCode,
					})
				} else if (obj.type === 20) {
					userDataInput.push({
						musthave: obj.musthave,
						explain: obj.explain,
						code: obj.code,
						codename: obj.codename,
						contents: obj.contents,
						tag: obj.tag,
						type: obj.type,
						category_details: obj.category_details,
						value: obj.items.value,
						qusType: '주관식',
						reserveGroupCode: this.$route.params.subCode,
					})
				} else if (obj.type === 21) {
					userDataInput.push({
						musthave: obj.musthave,
						explain: obj.explain,
						code: obj.code,
						codename: obj.codename,
						contents: obj.contents,
						tag: obj.tag,
						type: obj.type,
						category_details: obj.category_details,
						qusType: '파일업로드',
						imgFiles: this.imgFiles,
						reserveGroupCode: this.$route.params.subCode,
					})
				}
			})
			// let tags = ''
			// if (this.selectedTag.length > 0) {
			// 	let items = []
			// 	this.selectedTag.forEach(e => {
			// 		items.push(this.reservedaysData.commentTag[e])
			// 	})
			// 	tags = items.join(', ')
			// }
			const data = {
				ismarketing: 1,
				ispersonal: 1,
				stat: 9,
				custlike: this.radios.radioSelected,
				checkbox: checkBox.join('/'),
				textfiled: textfiled.join('/'),
				checkone: checkone.join('/'),
				date: this.$moment(new Date()).add(9, 'hour'),
				// counselorid: this.$store.state.counserlorLoginData.counselorid
				// 	? this.$store.state.counserlorLoginData.counselorid
				// 	: localStorage.getItem('counserlor').split(',')[1],
				// id: localStorage.getItem('waitingId'),
				id: this.waitingId,
				recomand: this.custComment,

				code: this.$route.params.code,
				// seat: Number(this.$store.state.counserlorLoginData.seat),
				locationData:
					this.$store.state.reservedayInputBox.categories.map(x => x.type).indexOf(20) > -1
						? this.$store.state.searchsel_city1.value +
						  '_' +
						  this.$store.state.searchsel_city2.value +
						  '_' +
						  this.$store.state.searchsel_city3.value
						: '',
				userData: userDataInput,
				sex: sex,
				realname: realname,
				age: age,
				qualification: qualification,
				homeOwnership: homeOwnership,
				bankBook: bankBook,
				purpose: purpose,
				subscribe: subscribe,
				floor: floor,
				houseAcreage: houseAcreage,
				acreageUnit: acreageUnit,
				location: location,
				locationType: locationType,
				marketing: this.$store.state.check5.value,
				receiveInformation: this.$store.state.check6.value,
				commentTag: `${userData.rankTitle ? userData.rankTitle : ''} ${userData.bonbuTitle ? userData.bonbuTitle : ''} ${
					userData.teamTitle ? userData.teamTitle : ''
				} ${userData.name ? userData.name : ''}`,
				groupcode: userData.phoneNumber,
			}
			if (ok === 0) {
				this.$store
					.dispatch('updateWaiting', data)
					.then(() => {
						const nickname = `${userData.rankTitle ? userData.rankTitle : ''} ${userData.bonbuTitle ? userData.bonbuTitle : ''} ${
							userData.teamTitle ? userData.teamTitle : ''
						} ${userData.nickname ? userData.nickname : userData.name}`
						this.createSendSm(this.phoneTxtfield.value, userData.nickname ? nickname : data.commentTag, userData.phoneNumber)
						this.createSendSm_counselor(userData.phoneNumber, this.nameTxtfield.value, this.phoneTxtfield.value)
						this.$store.state.counselor_reserve = null
						this.datatable_selectMembers.items = []
						this.nameTxtfield.value = ''
						this.phoneTxtfield.value = ''
						// this.$socket.emit('reservationBoard', { code: this.$route.params.code })
						// this.$socket.emit('reservationBoardList', { code: this.$route.params.code })
						// this.$socket.emit('reservation', { code: this.$route.params.code })
						this.counseringData = {}
						this.radios.radioSelected = ''
						this.check1.value = false
						this.check2.value = false
						this.check3.value = false
						this.waitingNumTxtfield.value = ''
						this.rankSelect.value = null
						this.$store.state.loading = false
						this.datatable.items = []
						this.selectedTag = []
						this.reservedays()

						this.updateSelectBox += 1
						this.custComment = '' // 코멘트 초기화
						localStorage.removeItem('waitingId') // localStorage waitingId 초기화
						localStorage.removeItem('counselingIdNow') // localStorage counselingIdNow 초기화
					})
					.catch(() => {
						this.$store.state.loading = false
					})
			}
		},
		setStat2() {
			const data = {
				stat: 2,
				// id: localStorage.getItem('waitingId'),
				id: this.waitingId,

				code: this.$route.params.code,
				// seat: Number(this.$store.state.counserlorLoginData.seat),
				// counselorid: this.$store.state.counserlorLoginData.counselorid
				// 	? this.$store.state.counserlorLoginData.counselorid
				// 	: localStorage.getItem('counserlor').split(',')[1],
				custlike: '미처리',
			}
			this.$store
				.dispatch('updateWaiting', data)
				.then(res => {
					// this.$socket.emit('reservationBoard', { code: this.$route.params.code })
					// this.$socket.emit('reservationBoardList', { code: this.$route.params.code })
					// this.$socket.emit('reservation', { code: this.$route.params.code })
					this.unattendedMessage(res.data.updateWaiting.waiting)
					this.counseringData = {}
					this.radios.radioSelected = ''
					this.check1.value = false
					this.check2.value = false
					this.check3.value = false

					this.waitingNumTxtfield.value = ''
					this.custComment = '' // 코멘트 초기화
					this.$store.state.loading = false
					this.datatable.items = []
					this.selectedTag = []
					this.reservedays()
					this.nameTxtfield.value = ''
					this.phoneTxtfield.value = ''
					localStorage.removeItem('waitingId') // localStorage waitingId 초기화
					localStorage.removeItem('counselingIdNow') // localStorage counselingIdNow 초기화
				})
				.catch(() => {
					this.$store.state.loading = false
				})
		},
		reservedays() {
			const data = {
				code: this.$route.params.code,
			}
			this.$store
				.dispatch('reservedays', data)
				.then(res => {
					this.placeTitle = res.data.reservedays[0].title
					this.reservedaysData = res.data.reservedays[0]
					this.logoutbtn.color = this.reservedaysData.business.color
					// 설문 데이터 value 삽입
					this.$store.state.reserveusersData.fileUpload = {}
					res.data.reservedays[0].input_box.categories.forEach(element => {
						if (element.type === 10) {
							element.value = ''
							element.items = { value: '', maxlength: '200', outlined: true, autofocus: false, hideDetail: true, errorMessage: '' }
							element.nowRadioValue = ''
							element.etc = ''
						} else if (element.type === 11) {
							element.category_details.forEach(detail => {
								if (!element.items) {
									element.items = []
								}
								element.items.push({
									value: '',
									label: detail.detailname,
									color: '',
									class: '',
									errorMessage: '',
									hideDetail: true,
									detailcode: detail.detailcode,
								})
							})
						} else if (element.type === 12) {
							element.items = { label: '', value: '', errorMessage: '', hideDetail: true, outlined: true }
						} else if (element.type === 20) {
							element.items = { value: '', maxlength: '255', outlined: true, autofocus: false, hideDetail: false, errorMessage: '' }
						}
					})
					if (res.data.reservedays[0].business) {
						if (res.data.reservedays[0].business.term) this.$store.state.termId = res.data.reservedays[0].business.term.id
						let li = []
						if (res.data.reservedays[0].business.useTerm) {
							li.push(res.data.reservedays[0].business.useTerm)
						} else li.push(null)
						if (res.data.reservedays[0].business.privacyTerm_waiting) {
							li.push(res.data.reservedays[0].business.privacyTerm_waiting)
						} else li.push(null)
						if (res.data.reservedays[0].business.uniqueTerm) {
							li.push(res.data.reservedays[0].business.uniqueTerm)
						} else li.push(null)
						if (res.data.reservedays[0].business.marketingTerm_reserveday) {
							li.push(res.data.reservedays[0].business.marketingTerm_reserveday)
						} else li.push(null)
						if (res.data.reservedays[0].business.adTerm) {
							li.push(res.data.reservedays[0].business.adTerm)
						} else li.push(null)
						this.$store.state.termIdList = li
					}
					res.data.reservedays[0].input_box.categories = res.data.reservedays[0].input_box.categories.filter(x => x.type < 29)
					this.$store.commit('reservedayInputBox', res.data.reservedays[0].input_box)
					this.$store.commit('reservedayInputBoxDirect', res.data.reservedays[0].input_box)
				})
				.catch(() => {})
		},
		waitings() {
			const data = {
				code: this.$route.params.code,
				seat: 0,
				stat: 0,
				csdate: this.$moment(new Date()).format('YYYY-MM-DD') + 'T00:00:00.000Z',
				cedate:
					this.$moment(new Date())
						.add(1, 'days')
						.format('YYYY-MM-DD') + 'T00:00:00.000Z',
				_limit: 1000,
			}
			this.$store
				.dispatch('waitings', data)
				.then(res => {
					this.datatable_reserveusers.items = res.data.waitings
				})
				.catch(() => {})
			// 		this.realTimeWatingList = res.data.waitings
			this.$store.dispatch('waitingsConnection', data).then(res => {
				const waitingsPeople = res.data.waitingsConnection.aggregate.count
				this.waitNum = waitingsPeople
			})
		},

		checkAgree() {
			if (this.check3.value) {
				this.check3.value = false
			}
		},
		disagree() {
			if (this.check3.value) {
				this.check1.value = false
				this.check2.value = false
			}
		},
		deleteAccount() {
			this.$router.push({ name: 'counselorlogin_reseve', params: { code: this.$route.params.code } })
			this.alertModal.dialog = false
		},

		clickDeleteBtn() {
			this.alertModal.dialog = true
		},
		logout() {
			localStorage.removeItem('counserlor')
			this.alertModal.dialog = true
		},
		changeTypeText(data) {
			if (data === 11) {
				return 'checkbox'
			} else if (data === 10 || data === 12) {
				return 'checkone'
			} else if (data === 20) {
				return 'textfiled'
			}
		},
		send() {
			if (this.waitNum > 0) {
				this.$store.state.loading = true
				const data = {
					code: this.$route.params.code,
					seat: 0,
					stat: 0,
					csdate: this.$moment(new Date()).format('YYYY-MM-DD') + 'T00:00:00.000Z',
					cedate:
						this.$moment(new Date())
							.add(1, 'days')
							.format('YYYY-MM-DD') + 'T00:00:00.000Z',
				}
				this.$store.dispatch('waitings', data).then(res => {
					if (res.data.waitings.length > 0) {
						let sorted = res.data.waitings.sort((a, b) => {
							if (a.waitingnum > b.waitingnum) return 1
							if (a.waitingnum === b.waitingnum) return 0
							if (a.waitingnum < b.waitingnum) return -1
						})
						if (sorted[0].locationData) {
							this.$store.state.searchsel_city2.items = location1[sorted[0].locationData.split('_')[0]].sort()
							if (this.$store.state.searchsel_city2.items.indexOf(sorted[0].locationData.split('_')[1]) > -1) {
								this.$store.state.searchsel_city2.value = sorted[0].locationData.split('_')[1]
								this.$store.state.searchsel_city3.items = location2[sorted[0].locationData.split('_')[0]][
									sorted[0].locationData.split('_')[1]
								].sort()
							}
							if (this.$store.state.searchsel_city2.items.indexOf(sorted[0].locationData.split('_')[2]) > -1)
								this.$store.state.searchsel_city3.value = sorted[0].locationData.split('_')[2]
							this.$store.state.searchsel_city1.value = sorted[0].locationData.split('_')[0]
						}
						this.waitingId = sorted[0].id
						const data = {
							id: this.waitingId,

							code: this.$route.params.code,
							stat: 1,
							seat: Number(this.$store.state.counserlorLoginData.seat),
							counselorid: this.$store.state.counserlorLoginData.counselorid
								? this.$store.state.counserlorLoginData.counselorid
								: localStorage.getItem('counserlor').split(',')[1],
						}
						this.$store
							.dispatch('updateWaiting', data)
							.then(updateRes => {
								setTimeout(() => {
									const data = {
										id: updateRes.data.updateWaiting.waiting.id,
									}
									this.$store.dispatch('waiting', data).then(oneRes => {
										if (oneRes.data.waiting.counselorid === this.$store.state.counserlorLoginData.counselorid) {
											// this.$socket.emit('reservationBoard', { code: this.$route.params.code })
											// this.$socket.emit('reservationBoardList', { code: this.$route.params.code })
											// this.$socket.emit('reservation', { code: this.$route.params.code })
											localStorage.setItem('waitingId', updateRes.data.updateWaiting.waiting.id)
											localStorage.setItem('counselingIdNow', this.$store.state.counserlorLoginData.counselorid)
											this.waitings()
											this.counseringData = sorted[0]
											this.nameTxtfield.value = sorted[0].name
											this.phoneTxtfield.value = sorted[0].phone
											this.assignments(sorted[0].phone)
											this.waitingNumTxtfield.value = String(sorted[0].waitingnum)
											if (sorted[0].ispersonal === 1) {
												this.check1.value = true
											} else {
												this.check3.value = true
											}
											if (sorted[0].ismarketing === 1) {
												this.check2.value = true
											} else {
												this.check3.value = true
											}
											// this.callMessage(sorted[0]) // 상담호출 메세지 전송
											this.$store.state.reserveusersData = sorted[0]
											this.$store.state.reservedayInputBox.categories.forEach(element => {
												if (element.type === 11) {
													if (sorted[0][this.changeTypeText(element.type)]) {
														sorted[0][this.changeTypeText(element.type)].split('/').forEach(type => {
															if (type.split(':')[0] === element.code) {
																type
																	.split(':')[1]
																	.split(',')
																	.forEach((detailCode, index) => {
																		element.items[index].value = detailCode
																	})
															}
														})
													}
												} else if (element.type === 10) {
													if (sorted[0][this.changeTypeText(element.type)]) {
														let etcArr = [] // 기타 값 임시저장
														let foundIdx
														// 기타 값 없을때 분기 필요
														if (sorted[0].etc !== null) {
															sorted[0].etc.split('/').forEach(el => {
																etcArr.push(el.split(':'))
															})
														}

														sorted[0][this.changeTypeText(element.type)].split('/').forEach(type => {
															if (type.split(':')[0] === element.code) {
																element.value = type.split(':')[1]
															}
														})

														// 기타 선택지 값 삽입
														foundIdx = etcArr.findIndex(x => x[0] === element.value)
														if (foundIdx !== -1) {
															element.etc = etcArr[foundIdx][1]
														}
													}
												} else if (element.type === 12) {
													if (sorted[0][this.changeTypeText(element.type)]) {
														sorted[0][this.changeTypeText(element.type)].split('/').forEach(type => {
															if (type.split(':')[0] === element.code) {
																element.items.value = type.split(':')[1]
															}
														})
													}
												} else if (element.type === 20) {
													if (sorted[0][this.changeTypeText(element.type)]) {
														sorted[0][this.changeTypeText(element.type)].split('/').forEach(type => {
															if (type.split(':')[0] === element.code) {
																element.items.value = type.split(':')[1]
															}
														})
													}
												}
											})

											const setData = this.$store.state.reservedayInputBox
											this.$store.commit('reservedayInputBox', {})
											setTimeout(() => {
												this.$store.state.loading = false
												this.$store.commit('reservedayInputBox', setData)
											}, 500)
										} else {
											alert('이미 호출된 회원입니다.')
											this.$store.state.loading = false
										}
									})
								}, 800)
							})
							.catch(err => {
								alert('이미 호출된 회원입니다.')
								console.log({ err })
								this.$store.state.loading = false
							})
					} else {
						alert('이미 호출된 회원입니다.')
						this.$store.state.loading = false
					}
					// })
					// .catch(() => {
					// 	this.$store.state.loading = false
					// 	alert('오류가 발생하였습니다. 관리자에게 문의하세요.')
				})
			}
		},
	},
}
</script>

<style lang="scss">
.waitingDialog {
	background-color: white !important;
}
.v-data-table-header-mobile {
	th {
		width: 100% !important;
	}
}
.forHistoryBtn {
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.counselorContents {
	margin-top: 100px !important;
	min-height: 89vh;
	height: auto;
}
.tracking-table {
	padding: 0px 40px 20px 40px;
}
.view-port_counselor {
	.viewport-item-counselor {
		padding-top: 16px !important;
	}
	display: flex;
	flex-flow: wrap;
	.viewport-item {
		padding: 10px 5px 5px 5px !important;
		justify-content: start !important;
		align-content: start !important;
		flex-grow: 0;
	}
	.surveyName {
		font-weight: bold !important;
	}
}
.fab-counselor-icon {
	bottom: 40px !important;
}
.fab-counselor-icon-2 {
	bottom: 65px !important;
	right: 50px !important;
}
.couselorHead {
	height: 80px !important;
	padding: 12px 0px 0px 20px;
	background-color: white !important;
	border-bottom: 1px solid #ffffff;
	border-color: #ffffff !important ;
	background: no-repeat left/contain url('../../assets/images/conselor_headerx2.png');
}
.bigHeader {
	font-size: 34px;
	font-weight: bold;
	color: white;
}
.couselorMain {
	max-width: 1060px;
	// width: 100vw;
}
.divider {
	border: 1px #cbd6da solid;
}
.rightSort {
	font-size: 14px;
	font-weight: bold;
}
.smallLabel {
	margin-top: 5px;
	.v-label {
		font-size: 14px;
		font-weight: bold;
		color: #a6a6a6 !important;
	}
}
.searchInput {
	.v-input__control {
		.v-input__slot {
			min-height: 26px !important;
		}
	}
}
.customerInfo {
	width: 200px !important;
	margin-top: 8px !important;
}
.counselorid {
	font-size: 16px;
	font-weight: bold;
	color: #0168b2;
}
.customerList {
	font-size: 16px;
	font-weight: bold;
	color: #6b567b;
}
.waitNum {
	span {
		font-size: 18px !important;
	}
	font-size: 18px;
	font-weight: bold;
	color: #4d4d4d;
}
.layout {
	min-width: 0px !important;
}
.counselorBack {
	background-color: white;
}
.pre-viewport_counselor {
	padding: 0px 15px 10px 15px;
	margin-top: 8px !important;
	background-color: white;

	.viewport-item {
		.width300 {
			width: 350px;
		}
		padding: 10px 0px;
		// border-bottom: 0.5px dashed #e0e0e0;
	}
}
.customerInfo-phone {
	.v-input__control {
		.v-input__slot {
			width: 200px !important;
			.v-text-field__slot {
				label {
					top: 9px !important;
					&.v-label--active {
						top: 16px !important;
					}
				}
			}
		}
	}
}
.vertical_divider {
	border-width: 0 2px 0 0 !important;
}
.counselor_content_wrap {
	max-height: calc(100vh - 100px);
	overflow-y: auto;
}
</style>
